/**
 * Do not edit directly, this file was auto-generated.
 */

export const avatarHeaderStrokeWeight = 6;
export const avatarHeaderCornerRadius = 9999;
export const avatarHeaderBorderRest = '#ffffff';
export const avatarHeaderBorderFocus = '#ffffff';
export const avatarHeaderBorderActive = '#1570ef';
export const avatarHeaderFillRest = '#ffffff';
export const avatarHeaderFillFocus = '#ffffff';
export const avatarHeaderFillActive = '#ffffff';
export const avatarHeaderEffectsColor = '#ffffff';
export const avatarHeaderEffectsBlur = 12;
export const avatarHeaderEffectsSpread = 0;
export const avatarHeaderTextRest = '#d9d9d9';
export const avatarHeaderTextFocus = '#ffffff';
export const avatarHeaderTextActive = '#ffffff';
export const avatarHeaderIconRest = '#ebebeb';
export const avatarHeaderIconFocus = '#ffffff';
export const avatarHeaderIconActive = '#ffffff';
export const avatarHeaderSizingContainer = 150;
export const avatarHeaderSizingText = 112;
export const avatarHeaderSizingIcon = 80;
export const avatarProfileStrokeWeight = 6;
export const avatarProfileCornerRadius = 9999;
export const avatarProfileBorderRest = '#ffffff';
export const avatarProfileBorderFocus = '#ffffff';
export const avatarProfileBorderSelected = '#1570ef';
export const avatarProfileFillRest = '#ffffff';
export const avatarProfileFillFocus = '#ffffff';
export const avatarProfileFillActive = '#ffffff';
export const avatarProfileEffectsColor = '#ffffff';
export const avatarProfileEffectsBlur = 20;
export const avatarProfileEffectsSpread = 0;
export const avatarProfileTextRest = '#d9d9d9';
export const avatarProfileTextFocus = '#ffffff';
export const avatarProfileTextActive = '#ffffff';
export const avatarProfileIconRest = '#ebebeb';
export const avatarProfileIconFocus = '#ffffff';
export const avatarProfileIconSelected = '#ffffff';
export const avatarProfileSizingContainerSmall = 200;
export const avatarProfileSizingContainerMedium = 240;
export const avatarProfileSizingContainerLarge = 350;
export const avatarProfileSizingTextSmall = 128;
export const avatarProfileSizingTextMedium = 144;
export const avatarProfileSizingTextLarge = 144;
export const avatarProfileSizingIconSmall = 88;
export const avatarProfileSizingIconMedium = 112;
export const avatarProfileSizingIconMobile = 128;
export const buttonSizingMinHeightSm = 56;
export const buttonSizingMinHeightMd = 72;
export const buttonSizingMinHeightLg = 88;
export const buttonSizingMinWidthSm = 120;
export const buttonSizingMinWidthMd = 128;
export const buttonSizingMinWidthLg = 144;
export const buttonSizingIconSm = 24;
export const buttonSizingIconMd = 32;
export const buttonSizingIconLg = 40;
export const buttonPaddingHorizontalNone = 0;
export const buttonPaddingHorizontalXs = 12;
export const buttonPaddingHorizontalSm = 16;
export const buttonPaddingHorizontalMd = 20;
export const buttonPaddingHorizontalLg = 24;
export const buttonPaddingVerticalNone = 0;
export const buttonPaddingVerticalXs = 12;
export const buttonPaddingVerticalSm = 16;
export const buttonPaddingVerticalMd = 20;
export const buttonPaddingVerticalLg = 24;
export const buttonSpacingIconTextSm = 4;
export const buttonSpacingIconTextMd = 8;
export const buttonSpacingIconTextLg = 12;
export const buttonCornerRadiusSm = 8;
export const buttonCornerRadiusMd = 10;
export const buttonCornerRadiusLg = 12;
export const buttonCornerRadiusPill = 9999;
export const buttonPrimaryFillRest = '#000000';
export const buttonPrimaryFillFocus = '#ffffff';
export const buttonPrimaryFillActive = '#1570ef';
export const buttonPrimaryFillActiveFocus = '#ffffff';
export const buttonPrimaryFillDisabled = '#000000';
export const buttonPrimaryStrokeWeight = 3;
export const buttonPrimaryBorderRest = '#ffffff';
export const buttonPrimaryBorderFocus = '#ffffff';
export const buttonPrimaryBorderActive = '#ffffff';
export const buttonPrimaryBorderActiveFocus = '#ffffff';
export const buttonPrimaryBorderDisabled = '#ffffff';
export const buttonPrimaryTextRest = '#ffffff';
export const buttonPrimaryTextFocus = '#141414';
export const buttonPrimaryTextActive = '#ffffff';
export const buttonPrimaryTextActiveFocus = '#141414';
export const buttonPrimaryTextDisabled = '#a6a6a6';
export const buttonPrimaryIconRest = '#ffffff';
export const buttonPrimaryIconFocus = '#141414';
export const buttonPrimaryIconActive = '#ffffff';
export const buttonPrimaryIconActiveFocus = '#141414';
export const buttonPrimaryIconDisabled = '#737373';
export const buttonPrimaryEffectDropShadowRender = true;
export const buttonPrimaryEffectDropShadowColor = '#000000';
export const buttonPrimaryEffectDropShadowXAxis = 0;
export const buttonPrimaryEffectDropShadowYAxis = 0;
export const buttonPrimaryEffectDropShadowBlur = 20;
export const buttonPrimaryEffectDropShadowSpread = 0;
export const buttonPrimaryEffectBackgroundBlur = 0;
export const buttonSecondaryStrokeWeight = 3;
export const buttonSecondaryFillRest = '#000000';
export const buttonSecondaryFillFocus = '#000000';
export const buttonSecondaryFillActive = '#1570ef';
export const buttonSecondaryFillActiveFocus = '#1570ef';
export const buttonSecondaryFillDisabled = '#000000';
export const buttonSecondaryBorderRest = '#ffffff';
export const buttonSecondaryBorderFocus = '#ffffff';
export const buttonSecondaryBorderActive = '#ffffff';
export const buttonSecondaryBorderActiveFocus = '#ffffff';
export const buttonSecondaryBorderDisabled = '#ffffff';
export const buttonSecondaryTextRest = '#ffffff';
export const buttonSecondaryTextFocus = '#ffffff';
export const buttonSecondaryTextActive = '#ffffff';
export const buttonSecondaryTextActiveFocus = '#ffffff';
export const buttonSecondaryTextDisabled = '#a6a6a6';
export const buttonSecondaryIconRest = '#ffffff';
export const buttonSecondaryIconFocus = '#ffffff';
export const buttonSecondaryIconActive = '#ffffff';
export const buttonSecondaryIconActiveFocus = '#ffffff';
export const buttonSecondaryIconDisabled = '#737373';
export const buttonSecondaryEffectBackgroundBlur = 0;
export const buttonSecondaryEffectDropShadowRender = true;
export const buttonSecondaryEffectDropShadowColor = '#000000';
export const buttonSecondaryEffectDropShadowXAxis = 0;
export const buttonSecondaryEffectDropShadowYAxis = 0;
export const buttonSecondaryEffectDropShadowBlur = 20;
export const buttonSecondaryEffectDropShadowSpread = 0;
export const buttonTertiaryStrokeWeight = 3;
export const buttonTertiaryFillRest = '#ffffff';
export const buttonTertiaryFillFocus = '#ffffff';
export const buttonTertiaryFillActive = '#ffffff';
export const buttonTertiaryFillActiveFocus = '#ffffff';
export const buttonTertiaryFillDisabled = '#ffffff';
export const buttonTertiaryBorderRest = '#ffffff';
export const buttonTertiaryBorderFocus = '#ffffff';
export const buttonTertiaryBorderActive = '#ffffff';
export const buttonTertiaryBorderActiveFocus = '#ffffff';
export const buttonTertiaryBorderDisabled = '#ffffff';
export const buttonTertiaryTextRest = '#ffffff';
export const buttonTertiaryTextFocus = '#ffffff';
export const buttonTertiaryTextActive = '#1570ef';
export const buttonTertiaryTextActiveFocus = '#1570ef';
export const buttonTertiaryTextDisabled = '#a6a6a6';
export const buttonTertiaryIconRest = '#ffffff';
export const buttonTertiaryIconFocus = '#ffffff';
export const buttonTertiaryIconActive = '#1570ef';
export const buttonTertiaryIconActiveFocus = '#1570ef';
export const buttonTertiaryIconDisabled = '#737373';
export const buttonTertiaryEffectDropShadowRender = true;
export const buttonTertiaryEffectDropShadowColor = '#000000';
export const buttonTertiaryEffectDropShadowXAxis = 0;
export const buttonTertiaryEffectDropShadowYAxis = 0;
export const buttonTertiaryEffectDropShadowBlur = 12;
export const buttonTertiaryEffectDropShadowSpread = 0;
export const calendarPaddingDateVertical = 24;
export const calendarPaddingDateHorizontal = 32;
export const calendarPaddingContainerVertical = 90;
export const calendarPaddingContainerHorizontal = 105;
export const calendarSpacingDateDateHorizontal = 16;
export const calendarSpacingDateLineDateVertical = 24;
export const calendarSpacingWeekdayWeekdayHorizontal = 16;
export const calendarSpacingHeaderHorizontal = 56;
export const calendarSpacingHeaderGridVertical = 102;
export const calendarSizingDateMinWidth = 75;
export const calendarSizingDateMinHeight = 75;
export const calendarContentFillContainer = '#000000';
export const calendarContentFillLines = '#ffffff';
export const calendarContentTextWeekdays = '#ffffff';
export const calendarContentTextHeader = '#ffffff';
export const calendarContentEffectsBackgroundBlurRender = true;
export const calendarContentEffectsBackgroundBlurBlurAmount = 32;
export const calendarContentEffectsDropShadowRender = true;
export const calendarContentEffectsDropShadowFill = '#000000';
export const calendarContentEffectsDropShadowXAxis = 0;
export const calendarContentEffectsDropShadowYAxis = 0;
export const calendarContentEffectsDropShadowBlur = 20;
export const calendarContentEffectsDropShadowSpread = 0;
export const calendarDateStrokeWeight = 2;
export const calendarDateCornerRadius = 4;
export const calendarDateFillRest = '#ffffff';
export const calendarDateFillToday = '#ffffff';
export const calendarDateFillTodayDisabled = '#ffffff';
export const calendarDateFillDisabled = '#ffffff';
export const calendarDateFillFocus = '#1570ef';
export const calendarDateFillTodayFocus = '#1570ef';
export const calendarDateFillTodayFocusDisabled = '#1570ef';
export const calendarDateFillDisabledFocus = '#1570ef';
export const calendarDateFillActive = '#ffffff';
export const calendarDateFillTodayActive = '#ffffff';
export const calendarDateFillTodayActiveDisabled = '#ffffff';
export const calendarDateFillDisabledActive = '#ffffff';
export const calendarDateBorderRest = '#ffffff';
export const calendarDateBorderToday = '#ffffff';
export const calendarDateBorderTodayDisabled = '#ffffff';
export const calendarDateBorderDisabled = '#ffffff';
export const calendarDateBorderFocus = '#ffffff';
export const calendarDateBorderTodayFocus = '#ffffff';
export const calendarDateBorderTodayFocusDisabled = '#ffffff';
export const calendarDateBorderDisabledFocus = '#ffffff';
export const calendarDateBorderActive = '#ffffff';
export const calendarDateBorderTodayActive = '#ffffff';
export const calendarDateBorderTodayActiveDisabled = '#ffffff';
export const calendarDateBorderDisabledActive = '#ffffff';
export const calendarDateTextRest = '#ffffff';
export const calendarDateTextToday = '#ffffff';
export const calendarDateTextTodayDisabled = '#ffffff';
export const calendarDateTextDisabled = '#ffffff';
export const calendarDateTextFocus = '#ffffff';
export const calendarDateTextTodayFocus = '#ffffff';
export const calendarDateTextTodayFocusDisabled = '#ffffff';
export const calendarDateTextDisabledFocus = '#ffffff';
export const calendarDateTextActive = '#ffffff';
export const calendarDateTextTodayActive = '#ffffff';
export const calendarDateTextTodayActiveDisabled = '#ffffff';
export const calendarDateTextDisabledActive = '#ffffff';
export const cardSizingLogoRatioHeightXs = 24;
export const cardSizingLogoRatioHeightSm = 32;
export const cardSizingLogoRatioHeightMd = 48;
export const cardSizingLogoRatioHeightLg = 56;
export const cardSizingLogoRatioHeightXl = 72;
export const cardSizingLogoRatioWidthXs = 48;
export const cardSizingLogoRatioWidthSm = 64;
export const cardSizingLogoRatioWidthMd = 96;
export const cardSizingLogoRatioWidthLg = 112;
export const cardSizingLogoRatioWidthXl = 144;
export const cardSizingTeamLogoLogoForegroundHeightXl = 200;
export const cardSizingTeamLogoLogoForegroundHeightLg = 136;
export const cardSizingTeamLogoLogoForegroundHeightMd = 100;
export const cardSizingTeamLogoLogoForegroundHeightSm = 80;
export const cardSizingTeamLogoLogoForegroundWidthXl = 200;
export const cardSizingTeamLogoLogoForegroundWidthLg = 136;
export const cardSizingTeamLogoLogoForegroundWidthMd = 100;
export const cardSizingTeamLogoLogoForegroundWidthSm = 80;
export const cardSizingTeamLogoLogoBackgroundWidthXl = 500;
export const cardSizingTeamLogoLogoBackgroundWidthLg = 409;
export const cardSizingTeamLogoLogoBackgroundWidthMd = 360;
export const cardSizingTeamLogoLogoBackgroundWidthSm = 236;
export const cardSizingTeamLogoLogoBackgroundHeightXl = 500;
export const cardSizingTeamLogoLogoBackgroundHeightLg = 409;
export const cardSizingTeamLogoLogoBackgroundHeightMd = 360;
export const cardSizingTeamLogoLogoBackgroundHeightSm = 236;
export const cardSizingTeamLogoTopSpanContainerWidth = 40;
export const cardSizingTeamLogoTopSpanContainerHeight = 40;
export const cardSizingTeamLogoBottomSpanContainerWidth = 40;
export const cardSizingTeamLogoBottomSpanContainerHeight = 40;
export const cardSizingIconsXs = 40;
export const cardSizingIconsImageRatioContainerWidth = 40;
export const cardSizingIconsImageRatioContainerHeight = 40;
export const cardSizingIcons2xs = 32;
export const cardSizingIconsSm = 48;
export const cardSizingIconsMd = 64;
export const cardSizingIconsLg = 80;
export const cardSizingIconsXl = 120;
export const cardSizingTileLandscapeHorizontalXs = 220;
export const cardSizingTileLandscapeHorizontalSm = 356;
export const cardSizingTileLandscapeHorizontalMd = 445;
export const cardSizingTileLandscapeHorizontalLg = 555;
export const cardSizingTileLandscapeHorizontalXl = 793;
export const cardSizingTileLandscapeVerticalXs = 124;
export const cardSizingTileLandscapeVerticalSm = 200;
export const cardSizingTileLandscapeVerticalMd = 250;
export const cardSizingTileLandscapeVerticalLg = 312;
export const cardSizingTileLandscapeVerticalXl = 446;
export const cardSizingTilePortraitHorizontalXs = 128;
export const cardSizingTilePortraitHorizontalSm = 208;
export const cardSizingTilePortraitHorizontalMd = 298;
export const cardSizingTilePortraitVerticalXs = 192;
export const cardSizingTilePortraitVerticalSm = 312;
export const cardSizingTilePortraitVerticalMd = 446;
export const cardSizingTileSquareHorizontalXs = 120;
export const cardSizingTileSquareHorizontalSm = 180;
export const cardSizingTileSquareHorizontalMd = 250;
export const cardSizingTileSquareVerticalXs = 120;
export const cardSizingTileSquareVerticalSm = 180;
export const cardSizingTileSquareVerticalMd = 250;
export const cardSizingTileRoundHorizontalXs = 120;
export const cardSizingTileRoundHorizontalSm = 180;
export const cardSizingTileRoundHorizontalMd = 250;
export const cardSizingTileRoundVerticalXs = 120;
export const cardSizingTileRoundVerticalSm = 180;
export const cardSizingTileRoundVerticalMd = 250;
export const cardSizingTileLabelHorizontalSm = 279;
export const cardSizingTileLabelHorizontalMd = 321;
export const cardSizingTileLabelHorizontalLg = 360;
export const cardSizingTileLabelVerticalSm = 120;
export const cardSizingTileLabelVerticalMd = 140;
export const cardSizingTileLabelVerticalLg = 160;
export const cardSizingTileLabelIconWidth = 48;
export const cardSizingTileLabelIconHeight = 48;
export const cardSizingTileWideHorizontalSm = 356;
export const cardSizingTileWideHorizontalMd = 445;
export const cardSizingTileWideHorizontalLg = 555;
export const cardSizingTileWideVerticalSm = 200;
export const cardSizingTileWideVerticalMd = 250;
export const cardSizingTileWideVerticalLg = 312;
export const cardSizingTileUpcomingGameHorizontalSm = 312;
export const cardSizingTileUpcomingGameHorizontalMd = 440;
export const cardSizingTileUpcomingGameHorizontalLg = 554;
export const cardSizingTileUpcomingGameHorizontalXl = 712;
export const cardSizingTileUpcomingGameVerticalSm = 262;
export const cardSizingTileUpcomingGameVerticalMd = 302;
export const cardSizingTileUpcomingGameVerticalLg = 380;
export const cardSizingTileUpcomingGameVerticalXl = 488;
export const cardSizingContentMetadataMinWidthSm = 740;
export const cardSizingContentMetadataMinWidthMd = 780;
export const cardSizingContentMetadataMinWidthLg = 820;
export const cardSizingTextMaxWidthSm = 190;
export const cardSizingTextMaxWidthMd = 220;
export const cardSizingTextMaxWidthLg = 250;
export const cardPaddingHorizontalNone = 0;
export const cardPaddingHorizontalXs = 8;
export const cardPaddingHorizontalSm = 12;
export const cardPaddingHorizontalMd = 16;
export const cardPaddingHorizontalLg = 20;
export const cardPaddingHorizontalXl = 24;
export const cardPaddingHorizontal2xl = 28;
export const cardPaddingHorizontal3xl = 32;
export const cardPaddingHorizontal4xl = 36;
export const cardPaddingHorizontal5xl = 40;
export const cardPaddingVerticalNone = 0;
export const cardPaddingVerticalXs = 8;
export const cardPaddingVerticalSm = 12;
export const cardPaddingVerticalMd = 16;
export const cardPaddingVerticalLg = 20;
export const cardPaddingVerticalXl = 24;
export const cardPaddingVertical2xl = 28;
export const cardPaddingVertical3xl = 32;
export const cardPaddingVertical4xl = 36;
export const cardPaddingVertical5xl = 40;
export const cardSpacingItemItemNone = 0;
export const cardSpacingItemItemXs = 4;
export const cardSpacingItemItemSm = 8;
export const cardSpacingItemItemMd = 12;
export const cardSpacingItemItemLg = 16;
export const cardSpacingItemItemXl = 20;
export const cardSpacingItemItem5xl = 40;
export const cardCornerRadiusNone = 0;
export const cardCornerRadiusXs = 4;
export const cardCornerRadiusSm = 6;
export const cardCornerRadiusMd = 8;
export const cardCornerRadiusLg = 10;
export const cardCornerRadiusXl = 12;
export const cardCornerRadius2xl = 16;
export const cardCornerRadiusRound = 9999;
export const cardElementsTileBottomSpanRender = true;
export const cardElementsTileBottomSpanDegree = 180;
export const cardElementsTileBottomSpanColorStop1 = '#000000';
export const cardElementsTileBottomSpanPositionStop1 = 5;
export const cardElementsTileBottomSpanColorStop2 = '#000000';
export const cardElementsTileBottomSpanPositionStop2 = 25;
export const cardElementsTileBottomSpanColorStop3 = '#000000';
export const cardElementsTileBottomSpanPositionStop3 = 60;
export const cardElementsTileBottomSpanColorStop4 = '#000000';
export const cardElementsTileBottomSpanPositionStop4 = 100;
export const cardElementsTileFallbackDefaultGrey = '#2b2b2b';
export const cardElementsMetadataFill = '#000000';
export const cardElementsMetadataBorder = '#ffffff';
export const cardElementsMetadataEffectsBackgroundBlurRender = false;
export const cardElementsMetadataEffectsBackgroundBlurBlurAmount = 0;
export const cardElementsMetadataText = '#ffffff';
export const cardElementsMetadataIcon = '#ffffff';
export const cardElementsMetadataStrokeWeight = '0';
export const cardContentStrokeWeight = 3;
export const cardContentFillRest = '#ffffff';
export const cardContentFillFocus = '#ffffff';
export const cardContentFillTeamColorLeft = '#002d62';
export const cardContentFillTeamColorRight = '#5a2d81';
export const cardContentBorderRest = '#ffffff';
export const cardContentBorderFocus = '#ffffff';
export const cardContentTextRest = '#ffffff';
export const cardContentTextFocus = '#ffffff';
export const cardContentIconRest = '#ffffff';
export const cardContentIconFocus = '#ffffff';
export const cardContentEffectsFocusRender = true;
export const cardContentEffectsFocusDropShadow = '#ffffff';
export const cardContentEffectsFocusXAxis = 0;
export const cardContentEffectsFocusYAxis = 0;
export const cardContentEffectsFocusBlur = 20;
export const cardContentEffectsFocusSpread = 0;
export const cardContentEffectsNonFocusRender = true;
export const cardContentEffectsNonFocusDropShadow = '#000000';
export const cardContentEffectsNonFocusXAxis = 0;
export const cardContentEffectsNonFocusYAxis = 0;
export const cardContentEffectsNonFocusBlur = 20;
export const cardContentEffectsNonFocusSpread = 2;
export const cardContentEffectsInnerShadowRender = true;
export const cardContentEffectsInnerShadowDropShadow = '#000000';
export const cardContentEffectsInnerShadowXAxis = 0;
export const cardContentEffectsInnerShadowYAxis = 0;
export const cardContentEffectsInnerShadowBlur = 36;
export const cardContentEffectsInnerShadowSpread = 0;
export const cardLabelFilledFillRest = '#000000';
export const cardLabelFilledFillFocus = '#ffffff';
export const cardLabelFilledFillActive = '#1570ef';
export const cardLabelFilledFillActiveFocus = '#ffffff';
export const cardLabelFilledFillDisabled = '#000000';
export const cardLabelFilledBorderRest = '#ffffff';
export const cardLabelFilledBorderFocus = '#ffffff';
export const cardLabelFilledBorderActive = '#ffffff';
export const cardLabelFilledBorderActiveFocus = '#ffffff';
export const cardLabelFilledBorderDisabled = '#ffffff';
export const cardLabelFilledTextRest = '#ffffff';
export const cardLabelFilledTextFocus = '#141414';
export const cardLabelFilledTextActive = '#ffffff';
export const cardLabelFilledTextActiveFocus = '#141414';
export const cardLabelFilledTextDisabled = '#a6a6a6';
export const cardLabelFilledIconRest = '#ffffff';
export const cardLabelFilledIconFocus = '#141414';
export const cardLabelFilledIconActive = '#ffffff';
export const cardLabelFilledIconActiveFocus = '#141414';
export const cardLabelFilledIconDisabled = '#737373';
export const cardLabelFilledEffectsFocusDropShadowRender = true;
export const cardLabelFilledEffectsFocusDropShadowColor = '#ffffff';
export const cardLabelFilledEffectsFocusDropShadowXAxis = 0;
export const cardLabelFilledEffectsFocusDropShadowYAxis = 0;
export const cardLabelFilledEffectsFocusDropShadowBlur = 32;
export const cardLabelFilledEffectsFocusDropShadowSpread = 0;
export const cardLabelFilledEffectsFocusBackgroundBlurRender = false;
export const cardLabelFilledEffectsFocusBackgroundBlurBlurAmount = 0;
export const cardLabelFilledEffectsNonFocusDropShadowRender = true;
export const cardLabelFilledEffectsNonFocusDropShadowColor = '#000000';
export const cardLabelFilledEffectsNonFocusDropShadowXAxis = 0;
export const cardLabelFilledEffectsNonFocusDropShadowYAxis = 0;
export const cardLabelFilledEffectsNonFocusDropShadowBlur = 32;
export const cardLabelFilledEffectsNonFocusDropShadowSpread = 2;
export const cardLabelFilledEffectsNonFocusBackgroundBlurRender = false;
export const cardLabelFilledEffectsNonFocusBackgroundBlurBlurAmount = 0;
export const cardLabelFilledStrokeWeight = 6;
export const cardLabelOutlinedStrokeWeight = 6;
export const cardLabelOutlinedFillRest = '#000000';
export const cardLabelOutlinedFillFocus = '#000000';
export const cardLabelOutlinedFillActive = '#1570ef';
export const cardLabelOutlinedFillActiveFocus = '#1570ef';
export const cardLabelOutlinedFillDisabled = '#000000';
export const cardLabelOutlinedBorderRest = '#ffffff';
export const cardLabelOutlinedBorderFocus = '#ffffff';
export const cardLabelOutlinedBorderActive = '#ffffff';
export const cardLabelOutlinedBorderActiveFocus = '#ffffff';
export const cardLabelOutlinedBorderDisabled = '#ffffff';
export const cardLabelOutlinedTextRest = '#ffffff';
export const cardLabelOutlinedTextFocus = '#ffffff';
export const cardLabelOutlinedTextActive = '#ffffff';
export const cardLabelOutlinedTextActiveFocus = '#ffffff';
export const cardLabelOutlinedTextDisabled = '#a6a6a6';
export const cardLabelOutlinedIconRest = '#ffffff';
export const cardLabelOutlinedIconFocus = '#ffffff';
export const cardLabelOutlinedIconActive = '#ffffff';
export const cardLabelOutlinedIconActiveFocus = '#ffffff';
export const cardLabelOutlinedIconDisabled = '#737373';
export const cardLabelOutlinedEffectsFocusDropShadowRender = true;
export const cardLabelOutlinedEffectsFocusDropShadowColor = '#ffffff';
export const cardLabelOutlinedEffectsFocusDropShadowXAxis = 0;
export const cardLabelOutlinedEffectsFocusDropShadowYAxis = 0;
export const cardLabelOutlinedEffectsFocusDropShadowBlur = 32;
export const cardLabelOutlinedEffectsFocusDropShadowSpread = 0;
export const cardLabelOutlinedEffectsFocusBackgroundBlurRender = false;
export const cardLabelOutlinedEffectsFocusBackgroundBlurBlurAmount = 0;
export const cardLabelOutlinedEffectsNonFocusDropShadowRender = true;
export const cardLabelOutlinedEffectsNonFocusDropShadowColor = '#000000';
export const cardLabelOutlinedEffectsNonFocusDropShadowXAxis = 0;
export const cardLabelOutlinedEffectsNonFocusDropShadowYAxis = 0;
export const cardLabelOutlinedEffectsNonFocusDropShadowBlur = 32;
export const cardLabelOutlinedEffectsNonFocusDropShadowSpread = 2;
export const cardLabelOutlinedEffectsNonFocusBackgroundBlurRender = false;
export const cardLabelOutlinedEffectsNonFocusBackgroundBlurBlurAmount = 0;
export const rest = '#ffffff';
export const focus = '#ffffff';
export const active = '#1570ef';
export const activeFocus = '#ffffff';
export const disabled = '#ffffff';
export const dropShadow = '#ffffff';
export const xAxis = 0;
export const yAxis = 0;
export const spread = 0;
export const blur = 36;
export const checkboxCornerRadius = 6;
export const checkboxSizingBoxWidth = 36;
export const checkboxSizingBoxHeight = 36;
export const checkboxSizingIconWidth = 32;
export const checkboxSizingIconHeight = 32;
export const checkboxStrokeWeight = 3;
export const checkboxUnselectedFillDefault = '#ffffff';
export const checkboxUnselectedFillFocus = '#ffffff';
export const checkboxUnselectedFillDisabled = '#ffffff';
export const checkboxUnselectedBorderDefault = '#8c8c8c';
export const checkboxUnselectedBorderFocus = '#ffffff';
export const checkboxUnselectedBorderDisabled = '#3d3d3d';
export const checkboxUnselectedIconDefault = '#ffffff';
export const checkboxUnselectedIconFocus = '#ffffff';
export const checkboxUnselectedIconDisabled = '#ffffff';
export const checkboxSelectedFillDefault = '#1570ef';
export const checkboxSelectedFillFocus = '#1570ef';
export const checkboxSelectedFillDisabled = '#3d3d3d';
export const checkboxSelectedBorderDefault = '#1570ef';
export const checkboxSelectedBorderFocus = '#ffffff';
export const checkboxSelectedBorderDisabled = '#3d3d3d';
export const checkboxSelectedIconDefault = '#ffffff';
export const checkboxSelectedIconFocus = '#ffffff';
export const checkboxSelectedIconDisabled = '#ffffff';
export const checkboxIndeterminateFillDefault = '#1570ef';
export const checkboxIndeterminateFillFocus = '#1570ef';
export const checkboxIndeterminateFillDisabled = '#3d3d3d';
export const checkboxIndeterminateBorderDefault = '#1570ef';
export const checkboxIndeterminateBorderFocus = '#ffffff';
export const checkboxIndeterminateBorderDisabled = '#3d3d3d';
export const checkboxIndeterminateIconDefault = '#ffffff';
export const checkboxIndeterminateIconFocus = '#ffffff';
export const checkboxIndeterminateIconDisabled = '#ffffff';
export const dropletsStrokeWeight = '0';
export const dropletsSizingBackgroundActiveWidth = 64;
export const dropletsSizingBackgroundActiveHeight = 20;
export const dropletsSizingBackgroundRestWidth = 20;
export const dropletsSizingBackgroundRestHeight = 20;
export const dropletsSizingHighlightIndicatorDefaultWidth = 20;
export const dropletsSizingHighlightIndicatorDefaultHeight = 20;
export const dropletsSizingHighlightIndicatorCompleteWidth = 64;
export const dropletsSizingHighlightIndicatorCompleteHeight = 20;
export const dropletsCornerRadius = 9999;
export const dropletsPaddingHorizontal = 0;
export const dropletsPaddingVertical = 0;
export const dropletsFillBackground = '#ffffff';
export const dropletsFillRest = '#ffffff';
export const dropletsFillFocus = '#ffffff';
export const dropletsFillActive = '#1570ef';
export const dropletsBorderRest = '#ffffff';
export const dropletsBorderFocus = '#ffffff';
export const dropletsBorderActive = '#ffffff';
export const dropletsEffectsBackgroundBlurRender = false;
export const dropletsEffectsBackgroundBlurBlurAmount = 0;
export const programCellHeight = 144;
export const programCellCornerRadius = 8;
export const programCellSizingIcon = 32;
export const programCellPaddingHorizontal = 24;
export const programCellPaddingVertical = 12;
export const programCellTextDuration = '#ffffff';
export const programCellTextTitle = '#ffffff';
export const programCellTextSubtitle = '#ffffff';
export const programCellFillOffRest = '#ffffff';
export const programCellFillOffFocus = '#ffffff';
export const programCellFillOnRest = '#ffffff';
export const programCellFillOnFocus = '#ffffff';
export const channelCellHeight = 144;
export const channelCellSizingIcon = 32;
export const channelCellPaddingVertical = 12;
export const channelCellPaddingHorizontal = 12;
export const channelCellCornerRadius = 8;
export const channelCellFillActive = '#ffffff';
export const channelCellFillRest = '#ffffff';
export const channelCellFillRestFocus = '#ffffff';
export const channelCellFillActiveFocus = '#ffffff';
export const channelCellColor = '#ffffff';
export const channelCellBorderRest = '#ffffff';
export const channelCellBorderFocus = '#ffffff';
export const heroMetadataStrokeWeight = '0';
export const heroMetadataFill = '#ffffff';
export const heroMetadataBorder = '#ffffff';
export const heroMetadataText = '#ffffff';
export const heroMetadataIcon = '#ffffff';
export const heroMetadataSizingLogoRatioPartnerChannelRectangularWidth = 192;
export const heroMetadataSizingLogoRatioPartnerChannelRectangularHeight = 96;
export const heroMetadataSizingLogoRatioPartnerChannelSquareWidth = 96;
export const heroMetadataSizingLogoRatioPartnerChannelSquareHeight = 96;
export const heroMetadataSizingLogoRatioContentWidth = 480;
export const heroMetadataSizingLogoRatioContentHeight = 240;
export const heroMetadataSizingWidth = 800;
export const heroMetadataSpacingXs = 8;
export const heroMetadataSpacingSm = 12;
export const heroMetadataSpacingMd = 16;
export const heroMetadataSpacingLg = 20;
export const heroMetadataSpacingXl = 24;
export const heroMetadataPaddingHorizontal = 0;
export const heroMetadataPaddingVertical = 0;
export const heroSizingPosterImageTopRightWidth = 1420;
export const heroSizingPosterImageTopRightHeight = 800;
export const heroSizingPosterImageFullWidth = 1920;
export const heroSizingPosterImageFullHeight = 1080;
export const heroSizingWidth = 1920;
export const heroSizingHeight = 920;
export const heroSizingLogoRatioSquareWidth = 96;
export const heroSizingLogoRatioSquareHeight = 96;
export const heroSizingLogoRatioTeamLogoMinWidth = 40;
export const heroSizingLogoRatioTeamLogoMinHeight = 40;
export const heroSizingLogoRatioLiveDotMinWidth = 24;
export const heroSizingLogoRatioLiveDotMinHeight = 24;
export const heroPaddingLeft = 80;
export const heroPaddingRight = 80;
export const heroPaddingTop = 220;
export const heroPaddingBottom = 24;
export const heroPaddingButtonsHorizontal = 0;
export const heroPaddingButtonsVertical = 0;
export const heroPaddingButtonVertical = 0;
export const heroSpacingBetweenContent = 48;
export const heroSpacingBetweenButtons = 16;
export const heroSpacingButtonButton = 16;
export const heroSpacingSm = 12;
export const heroSpacingLg = 20;
export const heroSpacing2xl = 28;
export const heroSpacing3xl = 32;
export const heroSpacing4xl = 36;
export const heroSpacing5xl = 40;
export const heroPaginationDropletsBackground = '#ffffff';
export const heroPaginationDropletsHighlightIndicatorRest = '#ffffff';
export const heroPaginationDropletsHighlightIndicatorFocus = '#ffffff';
export const heroPaginationDropletsEffectsBackgroundBlur = 0;
export const heroPaginationComponentCornerRadius = 9999;
export const heroPaginationComponentPaddingHorizontal = 24;
export const heroPaginationComponentPaddingVertical = 12;
export const heroPaginationComponentSpacingBetweenDroplets = 28;
export const heroProductInfoSizingTopStyleContainerWidth = 1920;
export const heroProductInfoSizingTopStyleContainerHeight = 864;
export const heroProductInfoSizingSideStyleContainerWidth = 1768;
export const heroProductInfoSizingSideStyleContainerHeight = 864;
export const heroProductInfoSpacingContent = 48;
export const heroProductInfoPosterContainerWidth = 1920;
export const heroProductInfoPosterContainerHeight = 864;
export const heroProductInfoMediaButtonsPaddingHorizontal = 0;
export const heroProductInfoMediaButtonsPaddingVertical = 0;
export const heroProductInfoMediaButtonsMediaSpacing = 16;
export const heroProductInfoMediaButtonsMediaContainerWidth = 800;
export const heroProductInfoMediaButtonsMediaPaddingHorizontal = 0;
export const heroProductInfoMediaButtonsMediaPaddingVertical = 0;
export const heroProductInfoMediaButtonsMediaTextTitle = '#ffffff';
export const heroProductInfoMediaButtonsMediaTextDescription = '#ffffff';
export const heroProductInfoMediaButtonsMediaMetadataText = '#ffffff';
export const heroProductInfoMediaButtonsMediaMetadataDotDivider = '#ffffff';
export const heroProductInfoMediaButtonsMediaMetadataSpacingTextRating = 16;
export const heroProductInfoMediaButtonsMediaMetadataSpacingTags = 8;
export const heroProductInfoMediaButtonsButtonsSpacing = 16;
export const heroProductInfoMediaButtonsButtonsPaddingVertical = 0;
export const heroProductInfoMediaButtonsButtonsPaddingHorizontal = 0;
export const heroProductInfoPaddingLeft = 80;
export const heroProductInfoPaddingRight = 80;
export const heroProductInfoPaddingTop = 200;
export const heroProductInfoPaddingBottom = 24;
export const heroProductInfoPaginationDropletsBackground = '#ffffff';
export const heroProductInfoPaginationDropletsCornerRadius = 9999;
export const heroProductInfoPaginationDropletsHighlightIndicatorRest =
  '#ffffff';
export const heroProductInfoPaginationDropletsHighlightIndicatorFocus =
  '#ffffff';
export const heroProductInfoPaginationDropletsHighlightIndicatorActive =
  '#1570ef';
export const heroProductInfoPaginationDropletsEffectsBlur = 0;
export const heroProductInfoPaginationComponentCornerRadius = 9999;
export const heroProductInfoPaginationComponentPaddingHorizontal = 24;
export const heroProductInfoPaginationComponentPaddingVertical = 12;
export const heroProductInfoPaginationComponentSpacingBetweenDroplets = 28;
export const heroLiveDotFill = '#1570ef';
export const heroLiveDotOutline = '#ffffff';
export const iconButtonPaddingHorizontalNone = 0;
export const iconButtonPaddingHorizontalXs = 12;
export const iconButtonPaddingHorizontalSm = 16;
export const iconButtonPaddingHorizontalMd = 20;
export const iconButtonPaddingHorizontalLg = 24;
export const iconButtonPaddingVerticalNone = 0;
export const iconButtonPaddingVerticalXs = 12;
export const iconButtonPaddingVerticalSm = 16;
export const iconButtonPaddingVerticalMd = 20;
export const iconButtonPaddingVerticalLg = 24;
export const iconButtonSpacingIconTextSm = 4;
export const iconButtonSpacingIconTextMd = 8;
export const iconButtonSpacingIconTextLg = 12;
export const iconButtonSizingMinHeightSm = 56;
export const iconButtonSizingMinHeightMd = 72;
export const iconButtonSizingMinHeightLg = 88;
export const iconButtonSizingMinWidthSm = 56;
export const iconButtonSizingMinWidthMd = 72;
export const iconButtonSizingMinWidthLg = 88;
export const iconButtonSizingIconSm = 24;
export const iconButtonSizingIconMd = 32;
export const iconButtonSizingIconLg = 40;
export const iconButtonCornerRadiusSm = 8;
export const iconButtonCornerRadiusMd = 10;
export const iconButtonCornerRadiusLg = 12;
export const iconButtonCornerRadiusPill = 9999;
export const iconButtonPrimaryFillRest = '#ffffff';
export const iconButtonPrimaryFillFocus = '#ffffff';
export const iconButtonPrimaryFillActive = '#1570ef';
export const iconButtonPrimaryFillActiveFocus = '#ffffff';
export const iconButtonPrimaryFillDisabled = '#ffffff';
export const iconButtonPrimaryBorderRest = '#ffffff';
export const iconButtonPrimaryBorderFocus = '#ffffff';
export const iconButtonPrimaryBorderActive = '#ffffff';
export const iconButtonPrimaryBorderActiveFocus = '#ffffff';
export const iconButtonPrimaryBorderDisabled = '#ffffff';
export const iconButtonPrimaryStrokeWeight = 3;
export const iconButtonPrimaryTextRest = '#ffffff';
export const iconButtonPrimaryTextFocus = '#141414';
export const iconButtonPrimaryTextActive = '#ffffff';
export const iconButtonPrimaryTextActiveFocus = '#141414';
export const iconButtonPrimaryTextDisabled = '#a6a6a6';
export const iconButtonPrimaryIconRest = '#ffffff';
export const iconButtonPrimaryIconFocus = '#141414';
export const iconButtonPrimaryIconActive = '#ffffff';
export const iconButtonPrimaryIconActiveFocus = '#141414';
export const iconButtonPrimaryIconDisabled = '#737373';
export const iconButtonPrimaryEffectsDropShadowColor = '#000000';
export const iconButtonPrimaryEffectsDropShadowXAxis = 0;
export const iconButtonPrimaryEffectsDropShadowYAxis = 0;
export const iconButtonPrimaryEffectsDropShadowBlur = 36;
export const iconButtonPrimaryEffectsDropShadowSpread = 0;
export const iconButtonPrimaryEffectsBackgroundBlur = 0;
export const iconButtonSecondaryStrokeWeight = 3;
export const iconButtonSecondaryEffectsDropShadowColor = '#000000';
export const iconButtonSecondaryEffectsDropShadowXAxis = 0;
export const iconButtonSecondaryEffectsDropShadowYAxis = 0;
export const iconButtonSecondaryEffectsDropShadowBlur = 36;
export const iconButtonSecondaryEffectsDropShadowSpread = 0;
export const iconButtonSecondaryEffectsBackgroundBlur = 0;
export const iconButtonSecondaryFillRest = '#ffffff';
export const iconButtonSecondaryFillFocus = '#ffffff';
export const iconButtonSecondaryFillActive = '#1570ef';
export const iconButtonSecondaryFillActiveFocus = '#1570ef';
export const iconButtonSecondaryFillDisabled = '#ffffff';
export const iconButtonSecondaryBorderRest = '#ffffff';
export const iconButtonSecondaryBorderFocus = '#ffffff';
export const iconButtonSecondaryBorderActive = '#ffffff';
export const iconButtonSecondaryBorderActiveFocus = '#ffffff';
export const iconButtonSecondaryBorderDisabled = '#ffffff';
export const iconButtonSecondaryTextRest = '#ffffff';
export const iconButtonSecondaryTextFocus = '#ffffff';
export const iconButtonSecondaryTextActive = '#ffffff';
export const iconButtonSecondaryTextActiveFocus = '#ffffff';
export const iconButtonSecondaryTextDisabled = '#a6a6a6';
export const iconButtonSecondaryIconRest = '#ffffff';
export const iconButtonSecondaryIconFocus = '#ffffff';
export const iconButtonSecondaryIconActive = '#ffffff';
export const iconButtonSecondaryIconActiveFocus = '#ffffff';
export const iconButtonSecondaryIconDisabled = '#737373';
export const iconButtonTertiaryStrokeWeight = 3;
export const iconButtonTertiaryFillRest = '#ffffff';
export const iconButtonTertiaryFillFocus = '#ffffff';
export const iconButtonTertiaryFillActive = '#ffffff';
export const iconButtonTertiaryFillActiveFocus = '#ffffff';
export const iconButtonTertiaryFillDisabled = '#ffffff';
export const iconButtonTertiaryBorderRest = '#ffffff';
export const iconButtonTertiaryBorderFocus = '#ffffff';
export const iconButtonTertiaryBorderActive = '#ffffff';
export const iconButtonTertiaryBorderActiveFocus = '#ffffff';
export const iconButtonTertiaryBorderDisabled = '#ffffff';
export const iconButtonTertiaryTextRest = '#ffffff';
export const iconButtonTertiaryTextFocus = '#ffffff';
export const iconButtonTertiaryTextActive = '#1570ef';
export const iconButtonTertiaryTextActiveFocus = '#1570ef';
export const iconButtonTertiaryTextDisabled = '#a6a6a6';
export const iconButtonTertiaryIconRest = '#ffffff';
export const iconButtonTertiaryIconFocus = '#ffffff';
export const iconButtonTertiaryIconActive = '#1570ef';
export const iconButtonTertiaryIconActiveFocus = '#1570ef';
export const iconButtonTertiaryIconDisabled = '#737373';
export const iconButtonTertiaryEffectsDropShadowColor = '#000000';
export const iconButtonTertiaryEffectsDropShadowXAxis = 0;
export const iconButtonTertiaryEffectsDropShadowYAxis = 0;
export const iconButtonTertiaryEffectsDropShadowBlur = 12;
export const iconButtonTertiaryEffectsDropShadowSpread = 0;
export const modalDialogSizingMinWidth = 800;
export const modalDialogSizingMaxWidth = 1200;
export const modalDialogSizingContentMinWidth = 736;
export const modalDialogSizingContentMaxWidth = 1120;
export const modalDialogSizingTileSmWidth = 356;
export const modalDialogSizingTileSmHeight = 200;
export const modalDialogSizingTileMdWidth = 445;
export const modalDialogSizingTileMdHeight = 250;
export const modalDialogSizingTileLgWidth = 555;
export const modalDialogSizingTileLgHeight = 312;
export const modalDialogSizingIconSmWidth = 52;
export const modalDialogSizingIconSmHeight = 52;
export const modalDialogSizingIconMdWidth = 64;
export const modalDialogSizingIconMdHeight = 64;
export const modalDialogSizingIconLgWidth = 80;
export const modalDialogSizingIconLgHeight = 80;
export const modalDialogPaddingNone = 0;
export const modalDialogPadding2xs = 4;
export const modalDialogPaddingXs = 8;
export const modalDialogPaddingSm = 12;
export const modalDialogPaddingMd = 16;
export const modalDialogPaddingLg = 20;
export const modalDialogPaddingXl = 24;
export const modalDialogPadding2xl = 28;
export const modalDialogPadding3xl = 32;
export const modalDialogPadding4xl = 36;
export const modalDialogPadding5xl = 40;
export const modalDialogSpacingNone = 0;
export const modalDialogSpacing2xs = 4;
export const modalDialogSpacingXs = 8;
export const modalDialogSpacingSm = 12;
export const modalDialogSpacingMd = 16;
export const modalDialogSpacingLg = 20;
export const modalDialogSpacingXl = 24;
export const modalDialogSpacing2xl = 28;
export const modalDialogSpacing3xl = 32;
export const modalDialogCornerRadiusSm = 8;
export const modalDialogCornerRadiusMd = 10;
export const modalDialogCornerRadiusLg = 12;
export const modalDialogCornerRadiusXl = 16;
export const modalDialogNeutralFill = '#000000';
export const modalDialogNeutralBorder = '#ffffff';
export const modalDialogNeutralText = '#ffffff';
export const modalDialogNeutralIcon = '#ffffff';
export const modalDialogNeutralEffectsDropShadowRender = true;
export const paginationStrokeWeight = '0';
export const paginationPaddingHorizontal = 24;
export const paginationPaddingVertical = 12;
export const paginationCornerRadius = 9999;
export const paginationFillRest = '#ffffff';
export const paginationFillFocus = '#1570ef';
export const paginationBorderRest = '#ffffff';
export const paginationBorderFocus = '#ffffff';
export const paginationSpacingBetweenDroplets = 28;
export const pinInputSizingMinHeightSm = 96;
export const pinInputSizingMinHeightMd = 116;
export const pinInputSizingMinHeightLg = 160;
export const pinInputSizingMinWidthSm = 80;
export const pinInputSizingMinWidthMd = 100;
export const pinInputSizingMinWidthLg = 144;
export const pinInputPaddingNone = 0;
export const pinInputPadding2xs = 4;
export const pinInputPaddingXs = 8;
export const pinInputPaddingSm = 12;
export const pinInputPaddingMd = 16;
export const pinInputPaddingLg = 20;
export const pinInputPaddingXl = 24;
export const pinInputPadding2xl = 28;
export const pinInputSpacingNone = 0;
export const pinInputSpacing2xs = 4;
export const pinInputSpacingXs = 8;
export const pinInputSpacingSm = 12;
export const pinInputSpacingMd = 16;
export const pinInputSpacingLg = 20;
export const pinInputSpacingXl = 24;
export const pinInputSpacing2xl = 28;
export const pinInputStrokeWeight = 3;
export const pinInputCornerRadiusSm = 8;
export const pinInputCornerRadiusMd = 10;
export const pinInputCornerRadiusLg = 12;
export const pinInputFieldFillRest = '#000000';
export const pinInputFieldFillFocus = '#000000';
export const pinInputFieldFillDisabled = '#000000';
export const pinInputFieldFillNegative = '#000000';
export const pinInputFieldFillSuccess = '#000000';
export const pinInputFieldBorderRest = '#ffffff';
export const pinInputFieldBorderFocus = '#ffffff';
export const pinInputFieldBorderDisabled = '#ffffff';
export const pinInputFieldBorderNegative = '#b42318';
export const pinInputFieldBorderSuccess = '#027a48';
export const pinInputFieldTextRest = '#d9d9d9';
export const pinInputFieldTextFocus = '#ffffff';
export const pinInputFieldTextDisabled = '#ffffff';
export const pinInputFieldTextNegative = '#d9d9d9';
export const pinInputFieldTextSuccess = '#d9d9d9';
export const pinInputFieldIconRest = '#ffffff';
export const pinInputFieldIconFocus = '#ffffff';
export const pinInputFieldIconDisabled = '#ffffff';
export const pinInputFieldIconNegative = '#f04438';
export const pinInputFieldIconSuccess = '#12b76a';
export const pinInputFieldEffectsBackgroundBlurRestRender = false;
export const pinInputFieldEffectsBackgroundBlurRestBlurAmount = 0;
export const pinInputFieldEffectsBackgroundBlurFocusRender = false;
export const pinInputFieldEffectsBackgroundBlurFocusBlurAmount = 0;
export const pinInputFieldEffectsBackgroundBlurDisabledRender = false;
export const pinInputFieldEffectsBackgroundBlurDisabledBlurAmount = 0;
export const pinInputFieldEffectsBackgroundBlurNegativeRender = false;
export const pinInputFieldEffectsBackgroundBlurNegativeBlurAmount = 0;
export const pinInputFieldEffectsBackgroundBlurSuccessRender = false;
export const pinInputFieldEffectsBackgroundBlurSuccessBlurAmount = 0;
export const pinInputFieldEffectsDropShadowRestRender = true;
export const pinInputFieldEffectsDropShadowRestColor = '#ffffff';
export const pinInputFieldEffectsDropShadowRestXAxis = 0;
export const pinInputFieldEffectsDropShadowRestYAxis = 0;
export const pinInputFieldEffectsDropShadowRestBlur = 16;
export const pinInputFieldEffectsDropShadowRestSpread = 0;
export const pinInputFieldEffectsDropShadowFocusRender = true;
export const pinInputFieldEffectsDropShadowFocusColor = '#2e90fa';
export const pinInputFieldEffectsDropShadowFocusXAxis = 0;
export const pinInputFieldEffectsDropShadowFocusYAxis = 0;
export const pinInputFieldEffectsDropShadowFocusBlur = 16;
export const pinInputFieldEffectsDropShadowFocusSpread = 0;
export const pinInputFieldEffectsDropShadowDisabledRender = false;
export const pinInputFieldEffectsDropShadowDisabledColor = '#ffffff';
export const pinInputFieldEffectsDropShadowDisabledXAxis = 0;
export const pinInputFieldEffectsDropShadowDisabledYAxis = 0;
export const pinInputFieldEffectsDropShadowDisabledBlur = 0;
export const pinInputFieldEffectsDropShadowDisabledSpread = 0;
export const pinInputFieldEffectsDropShadowNegativeRender = true;
export const pinInputFieldEffectsDropShadowNegativeColor = '#fda29b';
export const pinInputFieldEffectsDropShadowNegativeXAxis = 0;
export const pinInputFieldEffectsDropShadowNegativeYAxis = 0;
export const pinInputFieldEffectsDropShadowNegativeBlur = 10;
export const pinInputFieldEffectsDropShadowNegativeSpread = 0;
export const pinInputFieldEffectsDropShadowSuccessRender = true;
export const pinInputFieldEffectsDropShadowSuccessColor = '#6ce9a6';
export const pinInputFieldEffectsDropShadowSuccessXAxis = 0;
export const pinInputFieldEffectsDropShadowSuccessYAxis = 0;
export const pinInputFieldEffectsDropShadowSuccessBlur = 10;
export const pinInputFieldEffectsDropShadowSuccessSpread = 0;
export const playerControlsContentMetadataSizingMinHeight = 116;
export const playerControlsContentMetadataStrokeWeight = 6;
export const playerControlsContentMetadataFill = '#ffffff';
export const playerControlsContentMetadataBorder = '#ffffff';
export const playerControlsContentMetadataText = '#ffffff';
export const playerControlsContentMetadataIcon = '#ffffff';
export const playerControlsScrubberThumbnailSizingWidth = 445;
export const playerControlsScrubberThumbnailSizingHeight = 250;
export const playerControlsScrubberRender = false;
export const playerControlsScrubberFallbackDefaultGrey = '#2b2b2b';
export const playerControlsScrubberEffectsFocusRender = false;
export const playerControlsScrubberEffectsFocusXAxis = '#2b2b2b';
export const playerControlsScrubberEffectsNonFocusRender = false;
export const playerControlsScrubberEffectsNonFocusXAxis = '#2b2b2b';
export const playerControlsScrubberEffectsInnerShadowRender = false;
export const playerControlsScrubberEffectsInnerShadowXAxis = '#2b2b2b';
export const playerControlsSizingIconsWidth = 56;
export const playerControlsSizingIconsHeight = 56;
export const playerControlsSpacingNone = 0;
export const playerControlsSpacing2xs = 4;
export const playerControlsSpacingXs = 8;
export const playerControlsSpacingSm = 12;
export const playerControlsSpacingMd = 16;
export const playerControlsSpacingLg = 20;
export const playerControlsSpacingXl = 24;
export const playerControlsSpacing2xl = 28;
export const playerControlsSpacing3xl = 32;
export const playerControlsSpacing4xl = 36;
export const playerControlsSpacing5xl = 40;
export const playerControlsPaddingNone = 0;
export const playerControlsPadding2xs = 4;
export const playerControlsPaddingXs = 8;
export const playerControlsPaddingSm = 12;
export const playerControlsPaddingMd = 16;
export const playerControlsPaddingLg = 20;
export const playerControlsPaddingXl = 24;
export const playerControlsPadding2xl = 28;
export const playerControlsPadding3xl = 32;
export const playerControlsPadding4xl = 36;
export const playerControlsPadding5xl = 40;
export const playerControlsScrimTopSpanRender = true;
export const playerControlsScrimTopSpanDegree = 0;
export const playerControlsScrimTopSpanColorStop1 = '#000000';
export const playerControlsScrimTopSpanPositionStop1 = 0;
export const playerControlsScrimTopSpanColorStop2 = '#000000';
export const playerControlsScrimTopSpanPositionStop2 = 30;
export const playerControlsScrimTopSpanColorStop3 = '#000000';
export const playerControlsScrimTopSpanPositionStop3 = 60;
export const playerControlsScrimTopSpanColorStop4 = '#000000';
export const playerControlsScrimTopSpanPositionStop4 = 100;
export const playerControlsScrimBottomSpanRender = true;
export const playerControlsScrimBottomSpanDegree = 180;
export const playerControlsScrimBottomSpanColorStop1 = '#000000';
export const playerControlsScrimBottomSpanPositionStop1 = 0;
export const playerControlsScrimBottomSpanColorStop2 = '#000000';
export const playerControlsScrimBottomSpanPositionStop2 = 35;
export const playerControlsScrimBottomSpanColorStop3 = '#000000';
export const playerControlsScrimBottomSpanPositionStop3 = 70;
export const playerControlsScrimBottomSpanColorStop4 = '#000000';
export const playerControlsScrimBottomSpanPositionStop4 = 100;
export const playerControlsControlsStrokeWeight = '0';
export const playerControlsControlsFill = '#ffffff';
export const playerControlsControlsBorder = '#ffffff';
export const playerControlsControlsText = '#d9d9d9';
export const playerControlsControlsIcon = '#ebebeb';
export const playerControlsTabContextStrokeWeight = '0';
export const playerControlsTabContextFill = '#ffffff';
export const playerControlsTabContextBorder = '#ffffff';
export const playerControlsTabContextText = '#ffffff';
export const playerControlsTabContextIcon = '#ffffff';
export const playerControlsTabPanelCornerRadius = 20;
export const playerControlsTabPanelStrokeWeight = 3;
export const playerControlsTabPanelFill = '#ffffff';
export const playerControlsTabPanelEffectsBackgroundBlurRender = false;
export const playerControlsTabPanelEffectsBackgroundBlurBlurAmount = 0;
export const playerControlsTabPanelBorder = '#ffffff';
export const playerControlsTabPanelText = '#ffffff';
export const playerControlsTabPanelIcon = '#ffffff';
export const playerControlsTabPanelSizingMinHeight = 356;
export const colorBrandBrand0150 = '#eff8ff';
export const colorBrandBrand01100 = '#d1e9ff';
export const colorBrandBrand01200 = '#b2ddff';
export const colorBrandBrand01300 = '#84caff';
export const colorBrandBrand01400 = '#53b1fd';
export const colorBrandBrand01500 = '#2e90fa';
export const colorBrandBrand01600 = '#1570ef';
export const colorBrandBrand01700 = '#175cd3';
export const colorBrandBrand01800 = '#1849a9';
export const colorBrandBrand01900 = '#194185';
export const colorBrandBrand0250 = '#fff6ed';
export const colorBrandBrand02100 = '#ffead5';
export const colorBrandBrand02200 = '#fddcab';
export const colorBrandBrand02300 = '#feb273';
export const colorBrandBrand02400 = '#fd853a';
export const colorBrandBrand02500 = '#fb6514';
export const colorBrandBrand02600 = '#ec4a0a';
export const colorBrandBrand02700 = '#c4320a';
export const colorBrandBrand02800 = '#9c2a10';
export const colorBrandBrand02900 = '#7e2410';
export const colorBrandBrand0350 = '#ffffff';
export const colorOpacityBlack0 = '#000000';
export const colorOpacityBlack10 = '#000000';
export const colorOpacityBlack20 = '#000000';
export const colorOpacityBlack30 = '#000000';
export const colorOpacityBlack40 = '#000000';
export const colorOpacityBlack50 = '#000000';
export const colorOpacityBlack60 = '#000000';
export const colorOpacityBlack70 = '#000000';
export const colorOpacityBlack80 = '#000000';
export const colorOpacityBlack90 = '#000000';
export const colorOpacityBlack100 = '#000000';
export const colorOpacityWhite0 = '#ffffff';
export const colorOpacityWhite10 = '#ffffff';
export const colorOpacityWhite20 = '#ffffff';
export const colorOpacityWhite30 = '#ffffff';
export const colorOpacityWhite40 = '#ffffff';
export const colorOpacityWhite50 = '#ffffff';
export const colorOpacityWhite60 = '#ffffff';
export const colorOpacityWhite70 = '#ffffff';
export const colorOpacityWhite80 = '#ffffff';
export const colorOpacityWhite90 = '#ffffff';
export const colorOpacityWhite100 = '#ffffff';
export const colorOpacityBrand0150 = '#1570ef';
export const colorNeutral50 = '#ebebeb';
export const colorNeutral100 = '#d9d9d9';
export const colorNeutral200 = '#bfbfbf';
export const colorNeutral300 = '#a6a6a6';
export const colorNeutral400 = '#8c8c8c';
export const colorNeutral500 = '#737373';
export const colorNeutral600 = '#575757';
export const colorNeutral700 = '#3d3d3d';
export const colorNeutral800 = '#2b2b2b';
export const colorNeutral900 = '#141414';
export const colorNeutralWhite = '#ffffff';
export const colorNeutralBlack = '#000000';
export const colorBlue50 = '#eff8ff';
export const colorBlue100 = '#d1e9ff';
export const colorBlue200 = '#b2ddff';
export const colorBlue300 = '#84caff';
export const colorBlue400 = '#53b1fd';
export const colorBlue500 = '#2e90fa';
export const colorBlue600 = '#1570ef';
export const colorBlue700 = '#175cd3';
export const colorBlue800 = '#1849a9';
export const colorBlue900 = '#194185';
export const colorGreen50 = '#ecfdf3';
export const colorGreen100 = '#d1fadf';
export const colorGreen200 = '#a6f4c5';
export const colorGreen300 = '#6ce9a6';
export const colorGreen400 = '#32d583';
export const colorGreen500 = '#12b76a';
export const colorGreen600 = '#039855';
export const colorGreen700 = '#027a48';
export const colorGreen800 = '#05603a';
export const colorGreen900 = '#054f31';
export const colorYellow50 = '#fffaeb';
export const colorYellow100 = '#fef0c7';
export const colorYellow200 = '#fedf89';
export const colorYellow300 = '#fec84b';
export const colorYellow400 = '#fdb022';
export const colorYellow500 = '#f79009';
export const colorYellow600 = '#dc6803';
export const colorYellow700 = '#b54708';
export const colorYellow800 = '#93370d';
export const colorYellow900 = '#7a2e0e';
export const colorRed50 = '#fef3f2';
export const colorRed100 = '#fee4e2';
export const colorRed200 = '#fecdca';
export const colorRed300 = '#fda29b';
export const colorRed400 = '#f97066';
export const colorRed500 = '#f04438';
export const colorRed600 = '#d92d20';
export const colorRed700 = '#b42318';
export const colorRed800 = '#912018';
export const colorRed900 = '#7a271a';
export const colorOrange50 = '#fff6ed';
export const colorOrange100 = '#ffead5';
export const colorOrange200 = '#fddcab';
export const colorOrange300 = '#feb273';
export const colorOrange400 = '#fd853a';
export const colorOrange500 = '#fb6514';
export const colorOrange600 = '#ec4a0a';
export const colorOrange700 = '#c4320a';
export const colorOrange800 = '#9c2a10';
export const colorOrange900 = '#7e2410';
export const colorPrimarySubtle = '#2e90fa';
export const colorPrimaryDefault = '#1570ef';
export const colorPrimaryEmphasis = '#1849a9';
export const colorPrimaryDisabled = '#1570ef';
export const colorSecondarySubtle = '#fd853a';
export const colorSecondaryDefault = '#fb6514';
export const colorSecondaryEmphasis = '#c4320a';
export const colorLightNone = '#ffffff';
export const colorLightSubtle = '#ffffff';
export const colorLightDefault = '#ffffff';
export const colorLightEmphasis = '#ffffff';
export const colorLightFull = '#ffffff';
export const colorDarkNone = '#000000';
export const colorDarkSubtle = '#000000';
export const colorDarkDefault = '#000000';
export const colorDarkEmphasis = '#000000';
export const colorDarkFull = '#000000';
export const colorNegativeSubtle = '#fda29b';
export const colorNegativeDefault = '#f04438';
export const colorNegativeEmphasis = '#b42318';
export const colorWarningSubtle = '#fedf89';
export const colorWarningDefault = '#fdb022';
export const colorWarningEmphasis = '#dc6803';
export const colorSuccessSubtle = '#6ce9a6';
export const colorSuccessDefault = '#12b76a';
export const colorSuccessEmphasis = '#027a48';
export const colorTextXsubtle = '#737373';
export const colorTextSubtle = '#a6a6a6';
export const colorTextDefault = '#d9d9d9';
export const colorTextEmphasis = '#ffffff';
export const colorTextDisabled = '#ffffff';
export const colorTextInverse = '#141414';
export const colorTextPrimary = '#1570ef';
export const colorTextSecondary = '#fb6514';
export const colorTextDanger = '#f04438';
export const colorTextWarning = '#fdb022';
export const colorTextSuccess = '#12b76a';
export const colorIconSubtle = '#737373';
export const colorIconDefault = '#ebebeb';
export const colorIconEmphasis = '#ffffff';
export const colorIconDisabled = '#ffffff';
export const colorIconInverse = '#141414';
export const colorIconPrimary = '#1570ef';
export const colorIconSecondary = '#fb6514';
export const colorIconDanger = '#f04438';
export const colorIconWarning = '#fdb022';
export const colorIconSuccess = '#12b76a';
export const colorIconPremiumGoldOchreShadow = '#fdb022';
export const colorIconPremiumGoldYellowMiddle = '#fedf89';
export const colorIconPremiumGoldLightShine = '#fef0c7';
export const colorEffectDefault = '#000000';
export const spacingNone = 0;
export const spacingMinimal = 2;
export const spacing2xs = 4;
export const spacingXs = 8;
export const spacingSm = 12;
export const spacingMd = 16;
export const spacingLg = 20;
export const spacingXl = 24;
export const spacing2xl = 28;
export const spacing3xl = 32;
export const spacing4xl = 36;
export const spacing5xl = 40;
export const spacing6xl = 48;
export const spacing7xl = 56;
export const spacing8xl = 64;
export const spacing9xl = 72;
export const spacing10xl = 80;
export const spacing11xl = 88;
export const spacing12xl = 96;
export const sizing0 = 0;
export const sizingPoint = 1;
export const sizingMinimal = 2;
export const sizingXs = 4;
export const sizingSm = 8;
export const sizingMd = 16;
export const sizingLg = 20;
export const sizingXl = 24;
export const sizing2xl = 28;
export const sizing3xl = 32;
export const sizing4xl = 36;
export const sizing5xl = 40;
export const sizing6xl = 48;
export const sizing7xl = 56;
export const sizing8xl = 64;
export const sizing9xl = 72;
export const sizing10xl = 80;
export const sizing11xl = 88;
export const sizing12xl = 96;
export const typographyFontSize4px = 4;
export const typographyFontSize6px = 6;
export const typographyFontSize8px = 8;
export const typographyFontSize10px = 10;
export const typographyFontSize12px = 12;
export const typographyFontSize14px = 14;
export const typographyFontSize16px = 16;
export const typographyFontSize18px = 18;
export const typographyFontSize20px = 20;
export const typographyFontSize22px = 22;
export const typographyFontSize24px = 24;
export const typographyFontSize28px = 28;
export const typographyFontSize32px = 32;
export const typographyFontSize36px = 36;
export const typographyFontSize40px = 40;
export const typographyFontSize44px = 44;
export const typographyFontSize48px = 48;
export const typographyFontSize52px = 52;
export const typographyFontSize56px = 56;
export const typographyFontSize60px = 60;
export const typographyFontSize64px = 64;
export const typographyFontSize68px = 68;
export const typographyFontSize72px = 72;
export const typographyFontSize76px = 76;
export const typographyFontSize80px = 80;
export const typographyFontSize84px = 84;
export const typographyFontSize88px = 88;
export const typographyFontSize92px = 92;
export const typographyFontSize96px = 96;
export const typographyFontSize100px = 100;
export const typographyFontSize104px = 104;
export const typographyFontSize108px = 108;
export const typographyFontSize112px = 112;
export const typographyFontFamilyDefault = 'Outfit';
export const typographyFontFamilyAlternative = 'Outfit';
export const typographyFontWeightThin = 'thin';
export const typographyFontWeightExtraLight = 'extra light';
export const typographyFontWeightLight = 'light';
export const typographyFontWeightRegular = 'regular';
export const typographyFontWeightMedium = 'medium';
export const typographyFontWeightSemiBold = 'semi bold';
export const typographyFontWeightBold = 'bold';
export const typographyFontWeightExtraBold = 'extra bold';
export const typographyFontWeightBlack = 'black';
export const typographyLineHeightNone = 0;
export const typographyLineHeightTight = 90;
export const typographyLineHeightRegular = 100;
export const typographyLineHeightDistant = 120;
export const typographyLineHeightWide = 130;
export const typographySpacingLetterTight = -0.20000000298023224;
export const typographySpacingLetterRegular = 0;
export const typographySpacingLetterDistant = 1.5;
export const typographySpacingParagraphRegular = 0;
export const typographySpacingParagraphDistant = 24;
export const typographyTextCaseNone = 'none';
export const typographyTextCaseCapitalize = 'capitalize';
export const typographyTextCaseUppercase = 'uppercase';
export const typographyTextCaseLowercase = 'lowercase';
export const unit0 = 0;
export const unit1 = 1;
export const unit2 = 2;
export const unit3 = 3;
export const unit4 = 4;
export const unit6 = 6;
export const unit8 = 8;
export const unit10 = 10;
export const unit12 = 12;
export const unit14 = 14;
export const unit16 = 16;
export const unit18 = 18;
export const unit20 = 20;
export const unit22 = 22;
export const unit24 = 24;
export const unit26 = 26;
export const unit28 = 28;
export const unit32 = 32;
export const unit36 = 36;
export const unit40 = 40;
export const unit44 = 44;
export const unit48 = 48;
export const unit52 = 52;
export const unit56 = 56;
export const unit60 = 60;
export const unit64 = 64;
export const unit68 = 68;
export const unit72 = 72;
export const unit76 = 76;
export const unit80 = 80;
export const unit84 = 84;
export const unit88 = 88;
export const unit92 = 92;
export const unit96 = 96;
export const unit100 = 100;
export const unit104 = 104;
export const unit108 = 108;
export const unit112 = 112;
export const unit116 = 116;
export const unit120 = 120;
export const unit124 = 124;
export const unit128 = 128;
export const unit132 = 132;
export const unit144 = 144;
export const unit160 = 160;
export const unit176 = 176;
export const unit192 = 192;
export const unit208 = 208;
export const unit224 = 224;
export const unit240 = 240;
export const unit256 = 256;
export const unit288 = 288;
export const unit320 = 320;
export const unit384 = 384;
export const unit448 = 448;
export const unit512 = 512;
export const unit576 = 576;
export const unit672 = 672;
export const unit768 = 768;
export const unit896 = 896;
export const unit1024 = 1024;
export const unit1152 = 1152;
export const unit1280 = 1280;
export const unit9999 = 9999;
export const unitHalf = 0.5;
export const progressBarCornerRadius = 9999;
export const progressBarFillBackground = '#ffffff';
export const progressBarFillProgress = '#1570ef';
export const progressBarFillBuffer = '#1570ef';
export const progressBarContainerHeightXs = 6;
export const progressBarContainerHeightSm = 8;
export const progressBarContainerHeightMd = 10;
export const progressBarContainerHeightLg = 12;
export const progressBarContainerHeightXl = 16;
export const progressBarContainerHeight2xl = 18;
export const progressBarEffectsDropShadowRender = true;
export const progressBarEffectsDropShadowColor = '#000000';
export const progressBarEffectsDropShadowXAxis = 0;
export const progressBarEffectsDropShadowYAxis = 0;
export const progressBarEffectsDropShadowBlur = 12;
export const progressBarEffectsDropShadowSpread = 0;
export const progressBarEffectsBackgroundBlurRender = false;
export const progressBarEffectsBackgroundBlurBlurAmount = 0;
export const radioButtonSizingFrameWidth = 36;
export const radioButtonSizingFrameHeight = 36;
export const radioButtonSizingSelectedWidth = 26;
export const radioButtonSizingSelectedHeight = 26;
export const radioButtonCornerRadius = 9999;
export const radioButtonStrokeWeight = 3;
export const radioButtonUnselectedFillDefault = '#ffffff';
export const radioButtonUnselectedFillFocus = '#ffffff';
export const radioButtonUnselectedFillDisabled = '#ffffff';
export const radioButtonUnselectedBorderDefault = '#8c8c8c';
export const radioButtonUnselectedBorderFocus = '#ffffff';
export const radioButtonUnselectedBorderDisabled = '#3d3d3d';
export const radioButtonUnselectedIconDefault = '#ffffff';
export const radioButtonUnselectedIconFocus = '#ffffff';
export const radioButtonUnselectedIconDisabled = '#ffffff';
export const radioButtonSelectedFillDefault = '#1570ef';
export const radioButtonSelectedFillFocus = '#1570ef';
export const radioButtonSelectedFillDisabled = '#3d3d3d';
export const radioButtonSelectedBorderDefault = '#1570ef';
export const radioButtonSelectedBorderFocus = '#ffffff';
export const radioButtonSelectedBorderDisabled = '#3d3d3d';
export const radioButtonSelectedIconDefault = '#ffffff';
export const radioButtonSelectedIconFocus = '#ffffff';
export const radioButtonSelectedIconDisabled = '#ffffff';
export const railSizingTitleMinHeight = 40;
export const railSizingMetadataMediaMaxWidth = 1200;
export const railSizingComponentMinWidth = 1648;
export const railSizingComponentMaxWidth = 1920;
export const railSizingIconRectangularWidth = 56;
export const railSizingIconRectangularHeight = 24;
export const railSizingIconSquareWidth = 40;
export const railSizingIconSquareHeight = 40;
export const railSpacingTitleRail = 32;
export const railSpacingTitleIconLabel = 12;
export const railSpacingContainerCardCard = 24;
export const railSpacingMetadataItemItem = 16;
export const railPaddingLeft = 0;
export const railPaddingRight = 0;
export const railPaddingTop = 32;
export const railPaddingBottom = 40;
export const railPaddingTitleHorizontal = 80;
export const railPaddingTitleVertical = 0;
export const railPaddingContainerHorizontal = 80;
export const railPaddingContainerVertical = 6;
export const railPaddingCardContainerHorizontal = 80;
export const railPaddingCardContainerVertical = 0;
export const railPaddingMetadataHorizontal = 80;
export const railPaddingMetadataVertical = 0;
export const railDetailsViewTitle = '#ffffff';
export const railDetailsViewBody = '#ffffff';
export const railDetailsViewTimeStamp = '#d9d9d9';
export const railLandscapeStrokeWeight = '0';
export const railLandscapeFill = '#ffffff';
export const railLandscapeBorder = '#ffffff';
export const railLandscapeText = '#ffffff';
export const railLandscapeIcon = '#ffffff';
export const railPortraitStrokeWeight = '0';
export const railPortraitFill = '#ffffff';
export const railPortraitBorder = '#ffffff';
export const railPortraitText = '#ffffff';
export const railPortraitIcon = '#ffffff';
export const railTitleText = '#ffffff';
export const railTitleIcon = '#ffffff';
export const railSquareStrokeWeight = '0';
export const railSquareFill = '#ffffff';
export const railSquareBorder = '#ffffff';
export const railSquareText = '#ffffff';
export const railSquareIcon = '#ffffff';
export const railVodMovieStrokeWeight = 3;
export const railVodMovieFill = '#ffffff';
export const railVodMovieBorder = '#000000';
export const railVodMovieIcon = '#ebebeb';
export const railVodSeriesStrokeWeight = 3;
export const railVodSeriesFill = '#ffffff';
export const railVodSeriesBorder = '#000000';
export const railVodSeriesText = '#ffffff';
export const railVodSeriesIcon = '#ebebeb';
export const railGenreStrokeWeight = 3;
export const railGenreFill = '#ffffff';
export const railGenreBorder = '#000000';
export const railGenreText = '#ffffff';
export const railGenreIcon = '#ebebeb';
export const railChannelStrokeWeight = 3;
export const railChannelFill = '#ffffff';
export const railChannelBorder = '#000000';
export const railChannelText = '#ffffff';
export const railChannelIcon = '#ebebeb';
export const railLiveNowStrokeWeight = 3;
export const railLiveNowFill = '#ffffff';
export const railLiveNowBorder = '#000000';
export const railLiveNowText = '#ffffff';
export const railLiveNowIcon = '#ebebeb';
export const railTvodMoviesStrokeWeight = 3;
export const railTvodMoviesFill = '#ffffff';
export const railTvodMoviesBorder = '#000000';
export const railTvodMoviesText = '#ffffff';
export const railTvodMoviesIcon = '#ebebeb';
export const railTvodSeriesStrokeWeight = 3;
export const railTvodSeriesFill = '#ffffff';
export const railTvodSeriesBorder = '#000000';
export const railTvodSeriesText = '#ffffff';
export const railTvodSeriesIcon = '#ebebeb';
export const railCharacterStrokeWeight = 3;
export const railCharacterFill = '#ffffff';
export const railCharacterBorder = '#000000';
export const railCharacterText = '#ffffff';
export const railCharacterIcon = '#ebebeb';
export const railCastCrewStrokeWeight = 3;
export const railCastCrewFill = '#ffffff';
export const railCastCrewBorder = '#000000';
export const railCastCrewText = '#ffffff';
export const railCastCrewIcon = '#ebebeb';
export const railRoundStrokeWeight = '0';
export const railRoundFill = '#ffffff';
export const railRoundBorder = '#ffffff';
export const railRoundText = '#ffffff';
export const railRoundIcon = '#ffffff';
export const railLabelStrokeWeight = '0';
export const railLabelFill = '#ffffff';
export const railLabelBorder = '#ffffff';
export const railLabelText = '#ffffff';
export const railLabelIcon = '#ffffff';
export const railTrailerStrokeWeight = '0';
export const railTrailerFill = '#ffffff';
export const railTrailerBorder = '#ffffff';
export const railTrailerText = '#ffffff';
export const railTrailerIcon = '#ffffff';
export const railUpcomingGameStrokeWeight = '0';
export const railUpcomingGameFill = '#ffffff';
export const railUpcomingGameBorder = '#ffffff';
export const railUpcomingGameText = '#ffffff';
export const railUpcomingGameIcon = '#ffffff';
export const safeZoneHorizontal = 80;
export const safeZoneVertical = 70;
export const layoutCornerRadiusNone = 0;
export const layoutCornerRadiusMinimal = 2;
export const layoutCornerRadius2xs = 4;
export const layoutCornerRadiusXs = 6;
export const layoutCornerRadiusSm = 8;
export const layoutCornerRadiusMd = 10;
export const layoutCornerRadiusLg = 12;
export const layoutCornerRadiusXl = 16;
export const layoutCornerRadius2xl = 20;
export const layoutCornerRadius3xl = 24;
export const layoutCornerRadius4xl = 32;
export const layoutCornerRadius5xl = 36;
export const layoutCornerRadiusPill = 9999;
export const layoutBorderStrokeNone = 0;
export const layoutBorderStrokeThin = 1;
export const layoutBorderStrokeRegular = 2;
export const layoutBorderStrokeThick = 3;
export const layoutBorderStrokeHeavy = 6;
export const layoutBorderStrokeBlack = 12;
export const layoutSizingTvNone = 0;
export const layoutSizingTv2xs = 16;
export const layoutSizingTvXs = 20;
export const layoutSizingTvSm = 24;
export const layoutSizingTvMd = 32;
export const layoutSizingTvLg = 40;
export const layoutSizingTvXl = 48;
export const layoutSizingTv2xl = 56;
export const layoutSizingTv3xl = 64;
export const layoutSizingTv4xl = 72;
export const layoutSizingTv5xl = 80;
export const layoutSizingTv6xl = 88;
export const layoutSizingTv7xl = 96;
export const layoutSizingTv8xl = 104;
export const layoutSizingTv9xl = 112;
export const layoutSizingTv10xl = 120;
export const layoutSizingTv11xl = 128;
export const layoutSizingTv12xl = 144;
export const layoutSizingDesktopNone = 0;
export const layoutSizingDesktopNano = 4;
export const layoutSizingDesktop2xs = 8;
export const layoutSizingDesktopXs = 12;
export const layoutSizingDesktopSm = 16;
export const layoutSizingDesktopMd = 24;
export const layoutSizingDesktopLg = 32;
export const layoutSizingDesktopXl = 40;
export const layoutSizingDesktop2xl = 56;
export const layoutSizingDesktop3xl = 64;
export const layoutSizingTabletNone = 0;
export const layoutSizingTabletNano = 4;
export const layoutSizingTabletXxs = 8;
export const layoutSizingTabletXs = 12;
export const layoutSizingTabletSm = 16;
export const layoutSizingTabletMd = 20;
export const layoutSizingTabletLg = 24;
export const layoutSizingTabletXl = 32;
export const layoutSizingTabletXxl = 40;
export const layoutSizingMobileNone = 0;
export const layoutSizingMobileNano = 4;
export const layoutSizingMobileXxs = 8;
export const layoutSizingMobileXs = 12;
export const layoutSizingMobileSm = 16;
export const layoutSizingMobileMd = 20;
export const layoutSizingMobileLg = 24;
export const layoutSizingMobileXl = 32;
export const layoutSizingMobileXxl = 40;
export const layoutSpacingTvNone = 0;
export const layoutSpacingTv2xs = 4;
export const layoutSpacingTvXs = 8;
export const layoutSpacingTvSm = 12;
export const layoutSpacingTvMd = 16;
export const layoutSpacingTvLg = 20;
export const layoutSpacingTvXl = 24;
export const layoutSpacingTv2xl = 28;
export const layoutSpacingTv3xl = 32;
export const layoutSpacingTv4xl = 36;
export const layoutSpacingTv5xl = 40;
export const layoutSpacingTv6xl = 48;
export const layoutSpacingDesktopNone = 0;
export const layoutSpacingDesktopNano = 4;
export const layoutSpacingDesktop2xs = 8;
export const layoutSpacingDesktopXs = 12;
export const layoutSpacingDesktopSm = 16;
export const layoutSpacingDesktopMd = 24;
export const layoutSpacingDesktopLg = 32;
export const layoutSpacingDesktopXl = 40;
export const layoutSpacingDesktop2xl = 56;
export const layoutSpacingDesktop3xl = 64;
export const layoutSpacingTabletNone = 0;
export const layoutSpacingTabletNano = 4;
export const layoutSpacingTablet2xs = 8;
export const layoutSpacingTabletXs = 12;
export const layoutSpacingTabletSm = 16;
export const layoutSpacingTabletMd = 20;
export const layoutSpacingTabletLg = 24;
export const layoutSpacingTabletXl = 32;
export const layoutSpacingTablet2xl = 40;
export const layoutSpacingMobileNone = 0;
export const layoutSpacingMobileNano = 4;
export const layoutSpacingMobile2xs = 8;
export const layoutSpacingMobileXs = 12;
export const layoutSpacingMobileSm = 16;
export const layoutSpacingMobileMd = 20;
export const layoutSpacingMobileLg = 24;
export const layoutSpacingMobileXl = 32;
export const layoutSpacingMobile2xl = 40;
export const sideNavigationSizingAppLogoRectangularWidth = 192;
export const sideNavigationSizingAppLogoRectangularHeight = 96;
export const sideNavigationSizingAppLogoSquareWidth = 96;
export const sideNavigationSizingAppLogoSquareHeight = 96;
export const sideNavigationSizingAppLogoMinWidth = 32;
export const sideNavigationSizingAppLogoMinHeight = 40;
export const sideNavigationSizingMaxWidthNavigationTab = 1168;
export const sideNavigationSizingMaxWidthNavigationItem = 1168;
export const sideNavigationSizingMinWidth = 1920;
export const sideNavigationSizingMinHeight = 216;
export const sideNavigationSizingNavigationItemContainerCollapsedMinWidth = 32;
export const sideNavigationSizingNavigationItemContainerCollapsedMinHeight = 44;
export const sideNavigationSizingNavigationItemContainerExpandedMinWidth = 190;
export const sideNavigationSizingNavigationItemContainerExpandedMinHeight = 44;
export const sideNavigationSizingNavigationItemIconWidth = 32;
export const sideNavigationSizingNavigationItemIconHeight = 32;
export const sideNavigationPaddingNavigationTabHorizontal = 12;
export const sideNavigationPaddingNavigationTabVertical = 12;
export const sideNavigationPaddingNavigationItemHorizontal = 8;
export const sideNavigationPaddingNavigationItemVertical = 0;
export const sideNavigationPaddingLeft = 80;
export const sideNavigationPaddingRight = 80;
export const sideNavigationPaddingTop = 72;
export const sideNavigationPaddingBottom = 48;
export const sideNavigationPaddingNavigationVertical = 75;
export const sideNavigationPaddingNavigationLeft = 105;
export const sideNavigationPaddingNavigationRight = 0;
export const sideNavigationSpacingTabTab = 8;
export const sideNavigationSpacingItemItemOuter = 48;
export const sideNavigationSpacingItemItemInner = 24;
export const sideNavigationSpacingNavigationItem = 16;
export const sideNavigationStrokeWeight = '0';
export const sideNavigationFill = '#ffffff';
export const sideNavigationBorder = '#ffffff';
export const sideNavigationNavigationTabFill = '#000000';
export const sideNavigationNavigationTabBorder = '#ffffff';
export const sideNavigationNavigationTabStrokeWeight = 2;
export const sideNavigationNavigationTabCornerRadius = 9999;
export const sideNavigationNavigationTabEffectsBackgroundBlurRender = false;
export const sideNavigationNavigationTabEffectsBackgroundBlurBlurAmount = 0;
export const sideNavigationNavigationTabEffectsDropShadowRender = true;
export const sideNavigationNavigationTabEffectsDropShadowColor = '#000000';
export const sideNavigationNavigationTabEffectsDropShadowXAxis = 0;
export const sideNavigationNavigationTabEffectsDropShadowYAxis = 0;
export const sideNavigationNavigationTabEffectsDropShadowBlur = 40;
export const sideNavigationNavigationTabEffectsDropShadowSpread = 0;
export const sideNavigationNavigationItemFill = '#000000';
export const sideNavigationNavigationItemBorder = '#ffffff';
export const sideNavigationNavigationItemStrokeWeight = 2;
export const sideNavigationNavigationItemCornerRadius = 9999;
export const sideNavigationNavigationItemEffectsBackgroundBlurRender = false;
export const sideNavigationNavigationItemEffectsBackgroundBlurBlurAmount = 0;
export const sideNavigationNavigationItemEffectsDropShadowRender = true;
export const sideNavigationNavigationItemEffectsDropShadowColor = '#000000';
export const sideNavigationNavigationItemEffectsDropShadowXAxis = 0;
export const sideNavigationNavigationItemEffectsDropShadowYAxis = 0;
export const sideNavigationNavigationItemEffectsDropShadowBlur = 40;
export const sideNavigationNavigationItemEffectsDropShadowSpread = 0;
export const sideNavigationNavigationItemExpandedFillRest = '#ffffff';
export const sideNavigationNavigationItemExpandedFillFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedFillActive = '#ffffff';
export const sideNavigationNavigationItemExpandedFillActiveFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedFillDisabled = '#ffffff';
export const sideNavigationNavigationItemExpandedBorderRest = '#ffffff';
export const sideNavigationNavigationItemExpandedBorderFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedBorderActive = '#2e90fa';
export const sideNavigationNavigationItemExpandedBorderActiveFocus = '#2e90fa';
export const sideNavigationNavigationItemExpandedBorderDisabled = '#ffffff';
export const sideNavigationNavigationItemExpandedTextRest = '#ffffff';
export const sideNavigationNavigationItemExpandedTextFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedTextActive = '#ffffff';
export const sideNavigationNavigationItemExpandedTextActiveFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedTextDisabled = '#ffffff';
export const sideNavigationNavigationItemExpandedIconRest = '#ffffff';
export const sideNavigationNavigationItemExpandedIconFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedIconActive = '#ffffff';
export const sideNavigationNavigationItemExpandedIconActiveFocus = '#ffffff';
export const sideNavigationNavigationItemExpandedIconDisabled = '#ffffff';
export const sideNavigationNavigationItemExpandedBorderRadius = 6;
export const sideNavigationNavigationItemExpandedBorderWidth = 4;
export const sideNavigationNavigationItemCollapsedBorderRadius = 0;
export const sideNavigationNavigationItemCollapsedFillRest = '#ffffff';
export const sideNavigationNavigationItemCollapsedFillActive = '#ffffff';
export const sideNavigationNavigationItemCollapsedBorderRest = '#ffffff';
export const sideNavigationNavigationItemCollapsedBorderActive = '#2e90fa';
export const sideNavigationNavigationItemCollapsedIconRest = '#ffffff';
export const sideNavigationNavigationItemCollapsedIconActive = '#ffffff';
export const sideNavigationCornerRadius = 0;
export const sideNavigationContainerFill = '#000000';
export const snackbarSizingMinWidth = 800;
export const snackbarSizingMaxWidth = 1280;
export const snackbarSizingContentMinWidth = 349;
export const snackbarSizingContentMaxWidth = 829;
export const snackbarSizingIconWidth = 32;
export const snackbarSizingIconHeight = 32;
export const snackbarPaddingHorizontal = 36;
export const snackbarPaddingVertical = 36;
export const snackbarSpacing2xs = 4;
export const snackbarSpacingXs = 8;
export const snackbarSpacingSm = 12;
export const snackbarSpacingMd = 16;
export const snackbarSpacingLg = 20;
export const snackbarSpacingXl = 24;
export const snackbarSpacing2xl = 28;
export const snackbarSpacing3xl = 32;
export const snackbarFillNeutral = '#000000';
export const snackbarFillSuccess = '#000000';
export const snackbarFillWarning = '#000000';
export const snackbarFillDanger = '#000000';
export const snackbarBorderNeutral = '#2e90fa';
export const snackbarBorderSuccess = '#6ce9a6';
export const snackbarBorderWarning = '#fedf89';
export const snackbarBorderDanger = '#fda29b';
export const snackbarIconNeutral = '#1570ef';
export const snackbarIconSuccess = '#12b76a';
export const snackbarIconWarning = '#fdb022';
export const snackbarIconDanger = '#f04438';
export const snackbarTextNeutral = '#ffffff';
export const snackbarTextSuccess = '#ffffff';
export const snackbarTextWarning = '#ffffff';
export const snackbarTextDanger = '#ffffff';
export const snackbarEffectsDropShadowRender = true;
export const snackbarEffectsDropShadowColor = '#000000';
export const snackbarEffectsDropShadowXAxis = 0;
export const snackbarEffectsDropShadowYAxis = 0;
export const snackbarEffectsDropShadowBlur = 40;
export const snackbarEffectsDropShadowSpread = 0;
export const snackbarEffectsBackgroundBlurRender = false;
export const snackbarEffectsBackgroundBlurBlurAmount = 0;
export const snackbarStrokeWeight = 6;
export const snackbarCornerRadius = 10;
export const statsSizingContainerMinWidth = 602;
export const statsSizingContainerMinHeight = 947;
export const statsCornerRadiusContainer = 32;
export const statsCornerRadiusStatBar = 9999;
export const statsSpacingStatBarStatBarVertical = 48;
export const statsSpacingHeaderVertical = 0;
export const statsSpacingTeamScoresHorizontal = 40;
export const statsSpacingTeamScoresNumber = 0;
export const statsSpacingStatBarVertical = 12;
export const statsStatBarFillTeam1 = '#1d428a';
export const statsStatBarFillTeam2 = '#fab624';
export const statsStatBarTextStat = '#ffffff';
export const statsStatBarTextTeam1 = '#ffffff';
export const statsStatBarTextTeam2 = '#ffffff';
export const number = 0;
export const tabBarPaddingHorizontalNone = 0;
export const tabBarPaddingHorizontalSm = 12;
export const tabBarPaddingHorizontalMd = 16;
export const tabBarPaddingHorizontalLg = 20;
export const tabBarPaddingVerticalNone = 0;
export const tabBarPaddingVerticalSm = 12;
export const tabBarPaddingVerticalMd = 16;
export const tabBarPaddingVerticalLg = 20;
export const tabBarSpacingSm = 4;
export const tabBarSpacingMd = 8;
export const tabBarSpacingLg = 12;
export const tabBarCornerRadiusNone = 0;
export const tabBarCornerRadius2xs = 4;
export const tabBarCornerRadiusXs = 6;
export const tabBarCornerRadiusSm = 8;
export const tabBarCornerRadiusMd = 10;
export const tabBarCornerRadiusLg = 12;
export const tabBarCornerRadiusXl = 16;
export const tabBarCornerRadius2xl = 20;
export const tabBarCornerRadiusPill = 9999;
export const tabBarSegmentedHorizontalStrokeWeight = 2;
export const tabBarSegmentedHorizontalFill = '#000000';
export const tabBarSegmentedHorizontalBorder = '#ffffff';
export const tabBarSegmentedHorizontalEffectsDropShadowRender = true;
export const tabBarSegmentedHorizontalEffectsDropShadowColor = '#000000';
export const tabBarSegmentedHorizontalEffectsDropShadowXAxis = 0;
export const tabBarSegmentedHorizontalEffectsDropShadowYAxis = 0;
export const tabBarSegmentedHorizontalEffectsDropShadowBlur = 40;
export const tabBarSegmentedHorizontalEffectsDropShadowSpread = 0;
export const tabBarSegmentedHorizontalEffectsBackgroundBlurRender = false;
export const tabBarSegmentedHorizontalEffectsBackgroundBlurBlurAmount = 0;
export const tabBarSegmentedVerticalStrokeWeight = '0';
export const tabBarSegmentedVerticalFill = '#000000';
export const tabBarSegmentedVerticalBorder = '#ffffff';
export const tabBarSegmentedVerticalEffectsDropShadowRender = true;
export const tabBarSegmentedVerticalEffectsDropShadowColor = '#000000';
export const tabBarSegmentedVerticalEffectsDropShadowXAxis = 0;
export const tabBarSegmentedVerticalEffectsDropShadowYAxis = 0;
export const tabBarSegmentedVerticalEffectsDropShadowBlur = 40;
export const tabBarSegmentedVerticalEffectsDropShadowSpread = 0;
export const tabBarSegmentedVerticalEffectsBackgroundBlurRender = false;
export const tabBarSegmentedVerticalEffectsBackgroundBlurBlurAmount = 0;
export const tabBarLinedHorizontalStrokeWeight = '0';
export const tabBarLinedHorizontalFill = '#000000';
export const tabBarLinedHorizontalBorder = '#ffffff';
export const tabBarLinedHorizontalEffectsDropShadowRender = false;
export const tabBarLinedHorizontalEffectsDropShadowColor = '#000000';
export const tabBarLinedHorizontalEffectsDropShadowXAxis = 0;
export const tabBarLinedHorizontalEffectsDropShadowYAxis = 0;
export const tabBarLinedHorizontalEffectsDropShadowBlur = 0;
export const tabBarLinedHorizontalEffectsDropShadowSpread = 0;
export const tabBarLinedHorizontalEffectsBackgroundBlurRender = false;
export const tabBarLinedHorizontalEffectsBackgroundBlurBlurAmount = 0;
export const tabBarLinedVerticalStrokeWeight = '0';
export const tabBarLinedVerticalFill = '#000000';
export const tabBarLinedVerticalBorder = '#ffffff';
export const tabBarLinedVerticalEffectsDropShadowRender = false;
export const tabBarLinedVerticalEffectsDropShadowColor = '#000000';
export const tabBarLinedVerticalEffectsDropShadowXAxis = 0;
export const tabBarLinedVerticalEffectsDropShadowYAxis = 0;
export const tabBarLinedVerticalEffectsDropShadowBlur = 0;
export const tabBarLinedVerticalEffectsDropShadowSpread = 0;
export const tabBarLinedVerticalEffectsBackgroundBlurRender = false;
export const tabBarLinedVerticalEffectsBackgroundBlurBlurAmount = 0;
export const prototypeHome = 'home';
export const prototypeTvGuide = 'tv-guide';
export const prototypeMovies = 'movies';
export const prototypeSeries = 'movies';
export const prototypeKids = 'kids';
export const prototypeCategories = 'categories';
export const prototypeLibrary = 'categories';
export const tabSizingMinWidthSm = 56;
export const tabSizingMinWidthMd = 72;
export const tabSizingMinWidthLg = 88;
export const tabSizingMinHeightSm = 56;
export const tabSizingMinHeightMd = 72;
export const tabSizingMinHeightLg = 88;
export const tabSizingIconSm = 24;
export const tabSizingIconMd = 32;
export const tabSizingIconLg = 40;
export const tabPaddingHorizontalNone = 0;
export const tabPaddingHorizontalSm = 12;
export const tabPaddingHorizontalMd = 16;
export const tabPaddingHorizontalLg = 20;
export const tabPaddingHorizontalXl = 24;
export const tabPaddingVerticalNone = 0;
export const tabPaddingVerticalSm = 12;
export const tabPaddingVerticalMd = 16;
export const tabPaddingVerticalLg = 20;
export const tabPaddingVerticalXl = 24;
export const tabSpacingSm = 4;
export const tabSpacingMd = 8;
export const tabSpacingLg = 12;
export const tabCornerRadiusNone = 0;
export const tabCornerRadiusSm = 6;
export const tabCornerRadiusMd = 8;
export const tabCornerRadiusLg = 10;
export const tabCornerRadiusPill = 9999;
export const tabBorderStrokeSm = 3;
export const tabBorderStrokeMd = 3;
export const tabBorderStrokeLg = 3;
export const tabSegmentedStrokeWeight = 3;
export const tabSegmentedFillRest = '#ffffff';
export const tabSegmentedFillFocus = '#000000';
export const tabSegmentedFillActive = '#1570ef';
export const tabSegmentedFillActiveFocus = '#1570ef';
export const tabSegmentedFillDisabled = '#ffffff';
export const tabSegmentedBorderRest = '#ffffff';
export const tabSegmentedBorderFocus = '#ffffff';
export const tabSegmentedBorderActive = '#ffffff';
export const tabSegmentedBorderActiveFocus = '#ffffff';
export const tabSegmentedBorderDisabled = '#ffffff';
export const tabSegmentedTextRest = '#ffffff';
export const tabSegmentedTextFocus = '#ffffff';
export const tabSegmentedTextActive = '#ffffff';
export const tabSegmentedTextActiveFocus = '#ffffff';
export const tabSegmentedTextDisabled = '#a6a6a6';
export const tabSegmentedIconRest = '#ffffff';
export const tabSegmentedIconFocus = '#ffffff';
export const tabSegmentedIconActive = '#ffffff';
export const tabSegmentedIconActiveFocus = '#ffffff';
export const tabSegmentedIconDisabled = '#737373';
export const tabSegmentedEffectsDropShadowRender = true;
export const tabSegmentedEffectsDropShadowColor = '#000000';
export const tabSegmentedEffectsDropShadowXAxis = 0;
export const tabSegmentedEffectsDropShadowYAxis = 0;
export const tabSegmentedEffectsDropShadowBlur = 12;
export const tabSegmentedEffectsDropShadowSpread = 0;
export const tabSegmentedEffectsBackgroundBlurRender = false;
export const tabSegmentedEffectsBackgroundBlurBlurAmount = 0;
export const tabLinedStrokeWeight = 6;
export const tabLinedFillRest = '#ffffff';
export const tabLinedFillFocus = '#ffffff';
export const tabLinedFillActive = '#ffffff';
export const tabLinedFillActiveFocus = '#ffffff';
export const tabLinedBorderRest = '#ffffff';
export const tabLinedBorderFocus = '#ffffff';
export const tabLinedBorderActive = '#ffffff';
export const tabLinedBorderActiveFocus = '#ffffff';
export const tabLinedTextRest = '#d9d9d9';
export const tabLinedTextFocus = '#ffffff';
export const tabLinedTextActive = '#ffffff';
export const tabLinedTextActiveFocus = '#ffffff';
export const tabLinedEffectsDropShadowNonActiveRender = true;
export const tabLinedEffectsDropShadowNonActiveColor = '#000000';
export const tabLinedEffectsDropShadowNonActiveXAxis = 0;
export const tabLinedEffectsDropShadowNonActiveYAxis = 0;
export const tabLinedEffectsDropShadowNonActiveBlur = 20;
export const tabLinedEffectsDropShadowNonActiveSpread = 0;
export const tabLinedEffectsDropShadowActiveRender = true;
export const tabLinedEffectsDropShadowActiveColor = '#1570ef';
export const tabLinedEffectsDropShadowActiveXAxis = 0;
export const tabLinedEffectsDropShadowActiveYAxis = 0;
export const tabLinedEffectsDropShadowActiveBlur = 20;
export const tabLinedEffectsDropShadowActiveSpread = 0;
export const tabLinedIconRest = '#ebebeb';
export const tabLinedIconFocus = '#ffffff';
export const tabLinedIconActive = '#1570ef';
export const tabLinedIconActiveFocus = '#1570ef';
export const tabUnderlinedFillDisabled = '#ffffff';
export const tabUnderlinedBorderDisabled = '#ffffff';
export const tabUnderlinedTextDisabled = '#a6a6a6';
export const tabUnderlinedIconDisabled = '#737373';
export const tabPrototypeRestKey = 'rest';
export const tabPrototypeFocusKey = 'focus';
export const tabPrototypeSelectedKey = 'active';
export const tabPrototypeFocusSelectedKey = 'active-focus';
export const tabPrototypeDisabledKey = 'disabled';
export const metadataText = '#ffffff';
export const metadataDotDivider = '#737373';
export const metadataSizingIconWidth = 40;
export const metadataSizingIconHeight = 40;
export const metadataSizingIconSmallWidth = 24;
export const metadataSizingIconSmallHeight = 24;
export const metadataSpacingTagDivider = 8;
export const metadataSpacingScorePaddingHorizontalLg = 8;
export const metadataSpacingScorePaddingHorizontalSm = 0;
export const metadataSpacingScorePaddingVerticalLg = 16;
export const metadataSpacingScorePaddingVerticalSm = 8;
export const metadataSpacingScoreSpacingLg = 24;
export const metadataSpacingScoreSpacingMd = 16;
export const metadataSpacingScoreSpacingSm = 8;
export const tagPaddingHorizontal = 8;
export const tagPaddingVertical = 0;
export const tagSpacingItemItem = 4;
export const tagSizingMinHeightRectangular = 40;
export const tagSizingMinHeightPill = 40;
export const tagSizingMinHeightBasketballScore = 80;
export const tagSizingMinWidthRectangular = 40;
export const tagSizingMinWidthPill = 40;
export const tagSizingMinWidthBasketballScoreTag = 240;
export const tagSizingMinWidthBasketballScoreTeamAbbreviation = 72;
export const tagSizingMinWidthBasketballScoreScore = '0';
export const tagSizingIconSquareWidth = 24;
export const tagSizingIconSquareHeight = 24;
export const tagSizingIconRectangularWidth = 56;
export const tagSizingIconRectangularHeight = 24;
export const tagSizingImageRatioSquareWidth = 40;
export const tagSizingImageRatioSquareHeight = 40;
export const tagCornerRadiusSm = 4;
export const tagCornerRadiusMd = 6;
export const tagCornerRadiusLg = 8;
export const tagCornerRadiusPill = 9999;
export const tagRectangularStrokeWeight = 1;
export const tagRectangularFill = '#000000';
export const tagRectangularBorder = '#ffffff';
export const tagRectangularText = '#ffffff';
export const tagRectangularIcon = '#ffffff';
export const tagRectangularEffectsBlur = 0;
export const tagPillStrokeWeight = 1;
export const tagPillFill = '#000000';
export const tagPillBorder = '#ffffff';
export const tagPillText = '#ffffff';
export const tagPillIcon = '#ffffff';
export const tagPillEffectsBackgroundBlur = 0;
export const tagBasketballScoreLeftStrokeWeight = 3;
export const tagBasketballScoreLeftFill = '#ffffff';
export const tagBasketballScoreLeftBorder = '#ffffff';
export const tagBasketballScoreLeftText = '#ffffff';
export const tagBasketballScoreLeftIcon = '#ffffff';
export const tagBasketballScoreRightStrokeWeight = 3;
export const tagBasketballScoreRightFill = '#ffffff';
export const tagBasketballScoreRightBorder = '#ffffff';
export const tagBasketballScoreRightText = '#ffffff';
export const tagBasketballScoreRightIcon = '#ffffff';
export const textInputSizingMinHeight = 64;
export const textInputSizingMinWidth = 672;
export const textInputSizingIconWidth = 24;
export const textInputSizingIconHeight = 24;
export const textInputSizingTextMaxWidth = 568;
export const textInputPaddingNone = 0;
export const textInputPaddingXs = 8;
export const textInputPaddingSm = 12;
export const textInputPaddingMd = 16;
export const textInputPaddingLg = 20;
export const textInputPaddingXl = 24;
export const textInputSpacingNone = 0;
export const textInputSpacingXs = 8;
export const textInputSpacingSm = 12;
export const textInputSpacingMd = 16;
export const textInputSpacingLg = 20;
export const textInputSpacingXl = 24;
export const textInputStrokeWeight = 3;
export const textInputCornerRadius = 16;
export const textInputText = '#ffffff';
export const textInputFieldFillRest = '#000000';
export const textInputFieldFillFocus = '#000000';
export const textInputFieldFillDisabled = '#000000';
export const textInputFieldFillNegative = '#000000';
export const textInputFieldFillSuccess = '#000000';
export const textInputFieldBorderRest = '#ffffff';
export const textInputFieldBorderFocus = '#ffffff';
export const textInputFieldBorderDisabled = '#ffffff';
export const textInputFieldBorderNegative = '#b42318';
export const textInputFieldBorderSuccess = '#027a48';
export const textInputFieldTextRest = '#d9d9d9';
export const textInputFieldTextFocus = '#ffffff';
export const textInputFieldTextActive = '#ffffff';
export const textInputFieldTextDisabled = '#ffffff';
export const textInputFieldTextNegative = '#f04438';
export const textInputFieldTextSuccess = '#12b76a';
export const textInputFieldIconRest = '#ebebeb';
export const textInputFieldIconFocus = '#ffffff';
export const textInputFieldIconDisabled = '#ffffff';
export const textInputFieldIconNegative = '#f04438';
export const textInputFieldIconSuccess = '#12b76a';
export const textInputFieldEffectsBackgroundBlurRestRender = false;
export const textInputFieldEffectsBackgroundBlurRestBlurAmount = 0;
export const textInputFieldEffectsBackgroundBlurFocusRender = false;
export const textInputFieldEffectsBackgroundBlurFocusBlurAmount = 0;
export const textInputFieldEffectsBackgroundBlurDisabledRender = false;
export const textInputFieldEffectsBackgroundBlurDisabledBlurAmount = 0;
export const textInputFieldEffectsBackgroundBlurNegativeRender = false;
export const textInputFieldEffectsBackgroundBlurNegativeBlurAmount = 0;
export const textInputFieldEffectsBackgroundBlurSuccessRender = false;
export const textInputFieldEffectsBackgroundBlurSuccessBlurAmount = 0;
export const textInputFieldEffectsDropShadowRestRender = true;
export const textInputFieldEffectsDropShadowRestColor = '#ffffff';
export const textInputFieldEffectsDropShadowRestXAxis = 0;
export const textInputFieldEffectsDropShadowRestYAxis = 0;
export const textInputFieldEffectsDropShadowRestBlur = 16;
export const textInputFieldEffectsDropShadowRestSpread = 0;
export const textInputFieldEffectsDropShadowFocusRender = true;
export const textInputFieldEffectsDropShadowFocusColor = '#2e90fa';
export const textInputFieldEffectsDropShadowFocusXAxis = 0;
export const textInputFieldEffectsDropShadowFocusYAxis = 0;
export const textInputFieldEffectsDropShadowFocusBlur = 16;
export const textInputFieldEffectsDropShadowFocusSpread = 0;
export const textInputFieldEffectsDropShadowDisabledRender = false;
export const textInputFieldEffectsDropShadowDisabledColor = '#ffffff';
export const textInputFieldEffectsDropShadowDisabledXAxis = 0;
export const textInputFieldEffectsDropShadowDisabledYAxis = 0;
export const textInputFieldEffectsDropShadowDisabledBlur = 0;
export const textInputFieldEffectsDropShadowDisabledSpread = 0;
export const textInputFieldEffectsDropShadowNegativeRender = true;
export const textInputFieldEffectsDropShadowNegativeColor = '#fda29b';
export const textInputFieldEffectsDropShadowNegativeXAxis = 0;
export const textInputFieldEffectsDropShadowNegativeYAxis = 0;
export const textInputFieldEffectsDropShadowNegativeBlur = 10;
export const textInputFieldEffectsDropShadowNegativeSpread = 0;
export const textInputFieldEffectsDropShadowSuccessRender = true;
export const textInputFieldEffectsDropShadowSuccessColor = '#6ce9a6';
export const textInputFieldEffectsDropShadowSuccessXAxis = 0;
export const textInputFieldEffectsDropShadowSuccessYAxis = 0;
export const textInputFieldEffectsDropShadowSuccessBlur = 10;
export const textInputFieldEffectsDropShadowSuccessSpread = 0;
export const textInputIcon = '#ffffff';
export const textInputSupportingHintTextDefault = '#d9d9d9';
export const textInputSupportingHintTextNegative = '#f04438';
export const textInputSupportingHintTextWarning = '#fdb022';
export const textInputSupportingHintTextSuccess = '#12b76a';
export const textInputSupportingHintIconDefault = '#ebebeb';
export const textInputSupportingHintIconNegative = '#f04438';
export const textInputSupportingHintIconWarning = '#fdb022';
export const textInputSupportingHintIconSuccess = '#12b76a';
export const timeBarStrokeWeight = '0';
export const timeBarCornerRadius = 0;
export const timeBarFill = '#ffffff';
export const timeBarBorder = '#ffffff';
export const timeBarText = '#d9d9d9';
export const timeBarIcon = '#ebebeb';
export const timeBarSizingMinHeight = 36;
export const timeBarSizingSeekerWidth = 36;
export const timeBarSizingSeekerHeight = 36;
export const timeBarSpacingItemItem = 24;
export const timeBarSeekerStrokeWeight = 6;
export const timeBarSeekerCornerRadius = 9999;
export const timeBarSeekerFill = '#ffffff';
export const timeBarSeekerBorder = '#1570ef';
export const toggleSwitchCornerRadius = 9999;
export const toggleSwitchStrokeWeight = 3;
export const toggleSwitchSizingTrackWidth = 40;
export const toggleSwitchSizingTrackHeight = 24;
export const toggleSwitchSizingKnobWidth = 20;
export const toggleSwitchSizingKnobHeight = 20;
export const toggleSwitchEffectsDropShadowRender = true;
export const toggleSwitchEffectsDropShadowColor = '#000000';
export const toggleSwitchEffectsDropShadowXAxis = 0;
export const toggleSwitchEffectsDropShadowYAxis = 2;
export const toggleSwitchEffectsDropShadowBlur = 8;
export const toggleSwitchEffectsDropShadowSpread = 0;
export const toggleSwitchOnTrackFillDefault = '#1570ef';
export const toggleSwitchOnTrackFillFocus = '#1570ef';
export const toggleSwitchOnTrackFillDisabled = '#1570ef';
export const toggleSwitchOnTrackBorderDefault = '#ffffff';
export const toggleSwitchOnTrackBorderFocus = '#ffffff';
export const toggleSwitchOnTrackBorderDisabled = '#ffffff';
export const toggleSwitchOnKnobFillDefault = '#ffffff';
export const toggleSwitchOnKnobFillFocus = '#ffffff';
export const toggleSwitchOnKnobFillDisabled = '#8c8c8c';
export const toggleSwitchOnKnobBorderDefault = '#ffffff';
export const toggleSwitchOnKnobBorderFocus = '#ffffff';
export const toggleSwitchOnKnobBorderDisabled = '#8c8c8c';
export const toggleSwitchOffTrackFillDefault = '#8c8c8c';
export const toggleSwitchOffTrackFillFocus = '#8c8c8c';
export const toggleSwitchOffTrackFillDisabled = '#8c8c8c';
export const toggleSwitchOffTrackBorderDefault = '#ffffff';
export const toggleSwitchOffTrackBorderFocus = '#ffffff';
export const toggleSwitchOffTrackBorderDisabled = '#ffffff';
export const toggleSwitchOffKnob = '#ffffff';
export const topNavigationSizingAppLogoRectangularWidth = 192;
export const topNavigationSizingAppLogoRectangularHeight = 96;
export const topNavigationSizingAppLogoSquareWidth = 96;
export const topNavigationSizingAppLogoSquareHeight = 96;
export const topNavigationSizingMaxWidthNavigationTab = 1168;
export const topNavigationSizingMaxWidthNavigationItem = 1168;
export const topNavigationSizingMinWidth = 1920;
export const topNavigationSizingMinHeight = 216;
export const topNavigationSpacingTabTab = 8;
export const topNavigationPaddingLeft = 80;
export const topNavigationPaddingRight = 80;
export const topNavigationPaddingTop = 72;
export const topNavigationPaddingBottom = 48;
export const topNavigationStrokeWeight = '0';
export const topNavigationFill = '#ffffff';
export const topNavigationBorder = '#ffffff';
export const topNavigationNavigationTabFill = '#000000';
export const topNavigationNavigationTabBorder = '#ffffff';
export const topNavigationNavigationTabStrokeWeight = 2;
export const topNavigationNavigationTabEffectsBackgroundBlurRender = false;
export const topNavigationNavigationTabEffectsBackgroundBlurBlurAmount = 0;
export const topNavigationNavigationTabEffectsDropShadowRender = true;
export const topNavigationNavigationTabEffectsDropShadowColor = '#000000';
export const topNavigationNavigationTabEffectsDropShadowXAxis = 0;
export const topNavigationNavigationTabEffectsDropShadowYAxis = 0;
export const topNavigationNavigationTabEffectsDropShadowBlur = 40;
export const topNavigationNavigationTabEffectsDropShadowSpread = 0;
export const topNavigationNavigationTabCornerRadius = 9999;
export const topNavigationNavigationItemFill = '#000000';
export const topNavigationNavigationItemBorder = '#ffffff';
export const topNavigationNavigationItemStrokeWeight = 2;
export const topNavigationNavigationItemCornerRadius = 9999;
export const topNavigationNavigationItemEffectsBackgroundBlurRender = false;
export const topNavigationNavigationItemEffectsBackgroundBlurBlurAmount = 0;
export const topNavigationNavigationItemEffectsDropShadowRender = true;
export const topNavigationNavigationItemEffectsDropShadowColor = '#000000';
export const topNavigationNavigationItemEffectsDropShadowXAxis = 0;
export const topNavigationNavigationItemEffectsDropShadowYAxis = 0;
export const topNavigationNavigationItemEffectsDropShadowBlur = 40;
export const topNavigationNavigationItemEffectsDropShadowSpread = 0;
export const displayLargeFontFamily = 'Outfit';
export const displayLargeFontSize = 96;
export const displayLargeFontWeight = 'semi bold';
export const displayLargeLineHeight = 90;
export const displayLargeLetterSpacing = -0.20000000298023224;
export const displayLargeParagraphSpacing = 0;
export const displayMediumFontFamily = 'Outfit';
export const displayMediumFontSize = 64;
export const displayMediumFontWeight = 'semi bold';
export const displayMediumLineHeight = 90;
export const displayMediumLetterSpacing = -0.20000000298023224;
export const displayMediumParagraphSpacing = 0;
export const displaySmallFontFamily = 'Outfit';
export const displaySmallFontSize = 52;
export const displaySmallFontWeight = 'bold';
export const displaySmallLineHeight = 90;
export const displaySmallLetterSpacing = -0.20000000298023224;
export const displaySmallParagraphSpacing = 0;
export const titleLargeFontFamily = 'Outfit';
export const titleLargeFontSize = 44;
export const titleLargeFontWeight = 'medium';
export const titleLargeLineHeight = 100;
export const titleLargeLetterSpacing = -0.20000000298023224;
export const titleLargeParagraphSpacing = 0;
export const titleMediumFontFamily = 'Outfit';
export const titleMediumFontSize = 40;
export const titleMediumFontWeight = 'medium';
export const titleMediumLineHeight = 100;
export const titleMediumLetterSpacing = -0.20000000298023224;
export const titleMediumParagraphSpacing = 0;
export const titleSmallFontFamily = 'Outfit';
export const titleSmallFontSize = 32;
export const titleSmallFontWeight = 'semi bold';
export const titleSmallLineHeight = 100;
export const titleSmallLetterSpacing = -0.20000000298023224;
export const titleSmallParagraphSpacing = 0;
export const bodyLargeFontFamily = 'Outfit';
export const bodyLargeFontSize = 32;
export const bodyLargeFontWeightRegular = 'regular';
export const bodyLargeFontWeightSemiBold = 'semi bold';
export const bodyLargeLineHeight = 120;
export const bodyLargeLetterSpacing = -0.20000000298023224;
export const bodyLargeParagraphSpacing = 0;
export const bodyMediumFontFamily = 'Outfit';
export const bodyMediumFontSize = 24;
export const bodyMediumFontWeightRegular = 'regular';
export const bodyMediumFontWeightSemiBold = 'semi bold';
export const bodyMediumLineHeight = 120;
export const bodyMediumLetterSpacing = -0.20000000298023224;
export const bodyMediumParagraphSpacing = 0;
export const bodySmallFontFamily = 'Outfit';
export const bodySmallFontSize = 20;
export const bodySmallFontWeightRegular = 'regular';
export const bodySmallFontWeightSemiBold = 'semi bold';
export const bodySmallLineHeight = 120;
export const bodySmallLetterSpacing = -0.20000000298023224;
export const bodySmallParagraphSpacing = 0;
export const captionMediumFontFamily = 'Outfit';
export const captionMediumFontSize = 18;
export const captionMediumLineHeight = 120;
export const captionMediumLetterSpacing = -0.20000000298023224;
export const captionMediumParagraphSpacing = 0;
export const captionMediumFontWeightRegular = 'regular';
export const captionMediumFontWeightSemiBold = 'semi bold';
export const captionSmallFontFamily = 'Outfit';
export const captionSmallFontSize = 16;
export const captionSmallLineHeight = 120;
export const captionSmallLetterSpacing = -0.20000000298023224;
export const captionSmallParagraphSpacing = 0;
export const captionSmallFontWeightRegular = 'regular';
export const captionSmallFontWeightSemiBold = 'semi bold';
export const labelExtraLargeFontFamily = 'Outfit';
export const labelExtraLargeFontSize = 36;
export const labelExtraLargeLineHeight = 90;
export const labelExtraLargeLetterSpacing = 0;
export const labelExtraLargeParagraphSpacing = 0;
export const labelExtraLargeFontWeightRegular = 'regular';
export const labelExtraLargeFontWeightSemiBold = 'semi bold';
export const labelLargeFontFamily = 'Outfit';
export const labelLargeFontWeightRegular = 'regular';
export const labelLargeFontWeightSemiBold = 'semi bold';
export const labelLargeFontSize = 32;
export const labelLargeLineHeight = 90;
export const labelLargeLetterSpacing = 0;
export const labelLargeParagraphSpacing = 0;
export const labelMediumFontFamily = 'Outfit';
export const labelMediumFontSize = 28;
export const labelMediumLineHeight = 90;
export const labelMediumLetterSpacing = 0;
export const labelMediumParagraphSpacing = 0;
export const labelMediumFontWeightRegular = 'regular';
export const labelMediumFontWeightSemiBold = 'semi bold';
export const labelSmallFontFamily = 'Outfit';
export const labelSmallFontSize = 24;
export const labelSmallLineHeight = 90;
export const labelSmallLetterSpacing = 0;
export const labelSmallParagraphSpacing = 0;
export const labelSmallFontWeightRegular = 'regular';
export const labelSmallFontWeightSemiBold = 'semi bold';
export const labelExtraSmallFontFamily = 'Outfit';
export const labelExtraSmallFontSize = 20;
export const labelExtraSmallLineHeight = 90;
export const labelExtraSmallLetterSpacing = 0;
export const labelExtraSmallParagraphSpacing = 0;
export const labelExtraSmallFontWeightRegular = 'regular';
export const labelExtraSmallFontWeightSemiBold = 'semi bold';
